
<v-app class="v-app">
  <!-- 상단 공지 - 로그인 전 -->
  <div v-if="top_alert && !$store.getters.isLoggedIn" :style="{height: top_alert_height}" style="position: sticky; top: 0px; z-index: 99; width: 100%; background-color: #0D0E17">
    <!-- show-over-1441 -->
    <div class="show-over-1441" style="width: 100%; height: 100%">
      <div v-if="fontReady" class="d-flex align-center justify-space-between" style="width: 100%; height: 100%; padding: 0px 160px; cursor: pointer" @click="clickTopAlert()">
        <!-- title, sub -->
        <div>
          <!-- title -->
          <div style="font-weight: 700; font-size: 16px; line-height: 22px; letter-spacing: -0.02em; color: #FF6A39">
            Nextrise 스타트업 아우토반에 리컬럼이 참가합니다. (6/26~6/27)
          </div>
          <!-- sub -->
          <div class="d-flex align-center" style="width: fit-content; gap: 2px; border-bottom: 1px solid #ffffff" @click.stop="clickTopAlert_sub()">
            <div style="font-weight: 400; font-size: 16px; line-height: 21px; letter-spacing: -0.02em; color: #ffffff">
              NextRise 공식 페이지 바로가기
            </div>
            <v-icon style="font-size: 16px; color: #ffffff">
              mdi-arrow-right
            </v-icon>
          </div>
        </div>
        <!-- icon -->
        <v-icon style="font-size: 20px; color: #ffffff">
          mdi-chevron-right
        </v-icon>
      </div>
    </div>
    <!-- show-over-1025-under-1440 -->
    <div class="show-over-1025-under-1440" style="width: 100%; height: 100%">
      <div v-if="fontReady" class="d-flex align-center justify-space-between" style="width: 100%; height: 100%; padding: 0px 100px; cursor: pointer" @click="clickTopAlert()">
        <!-- title, sub -->
        <div>
          <!-- title -->
          <div style="font-weight: 700; font-size: 16px; line-height: 140%; letter-spacing: -0.02em; color: #FF6A39">
            Nextrise 스타트업 아우토반에 리컬럼이 참가합니다. (6/26~6/27)
          </div>
          <!-- sub -->
          <div class="d-flex align-center" style="width: fit-content; gap: 2px; border-bottom: 1px solid #ffffff" @click.stop="clickTopAlert_sub()">
            <div style="font-weight: 400; font-size: 16px; line-height: 21px; letter-spacing: -0.02em; color: #ffffff">
              NextRise 공식 페이지 바로가기
            </div>
            <v-icon style="font-size: 16px; color: #ffffff">
              mdi-arrow-right
            </v-icon>
          </div>
        </div>
        <!-- icon -->
        <v-icon style="font-size: 20px; color: #ffffff">
          mdi-chevron-right
        </v-icon>
      </div>
    </div>
    <!-- show-over-769-under-1024 -->
    <div class="show-over-769-under-1024" style="width: 100%; height: 100%">
      <div v-if="fontReady" class="d-flex align-center justify-space-between" style="width: 100%; height: 100%; padding: 0px 20px; cursor: pointer" @click="clickTopAlert()">
        <!-- title, sub -->
        <div>
          <!-- title -->
          <div style="font-weight: 700; font-size: 16px; line-height: 140%; letter-spacing: -0.02em; color: #FF6A39">
            Nextrise 스타트업 아우토반에 리컬럼이 참가합니다. (6/26~6/27)
          </div>
          <!-- sub -->
          <div class="d-flex align-center" style="width: fit-content; gap: 2px; border-bottom: 1px solid #ffffff" @click.stop="clickTopAlert_sub()">
            <div style="font-weight: 400; font-size: 16px; line-height: 21px; letter-spacing: -0.02em; color: #ffffff">
              NextRise 공식 페이지 바로가기
            </div>
            <v-icon style="font-size: 16px; color: #ffffff">
              mdi-arrow-right
            </v-icon>
          </div>
        </div>
        <!-- icon -->
        <v-icon style="font-size: 20px; color: #ffffff">
          mdi-chevron-right
        </v-icon>
      </div>
    </div>
    <!-- show-over-481-under-768 -->
    <div class="show-over-481-under-768" style="width: 100%; height: 100%">
      <div v-if="fontReady" class="d-flex align-center justify-space-between" style="width: 100%; height: 100%; padding: 0px 20px; cursor: pointer" @click="clickTopAlert()">
        <!-- title, sub -->
        <div>
          <!-- title -->
          <div style="font-weight: 700; font-size: 17px; line-height: 140%; letter-spacing: -0.03em; color: #FF6A39">
            Nextrise 스타트업 아우토반에 리컬럼이 참가합니다. (6/26~6/27)
          </div>
          <!-- sub -->
          <div class="d-flex align-center" style="width: fit-content; gap: 2px; border-bottom: 1px solid #ffffff" @click.stop="clickTopAlert_sub()">
            <div style="font-weight: 400; font-size: 17px; line-height: 23px; letter-spacing: -0.03em; color: #ffffff">
              NextRise 공식 페이지 바로가기
            </div>
            <v-icon style="font-size: 16px; color: #ffffff">
              mdi-arrow-right
            </v-icon>
          </div>
        </div>
      </div>
    </div>
    <!-- show-over-320-under-480 -->
    <div class="show-over-320-under-480" style="width: 100%; height: 100%">
      <div v-if="fontReady" class="d-flex align-center justify-space-between" style="width: 100%; height: 100%; padding: 0px 20px; cursor: pointer; position: relative" @click="clickTopAlert()">
        <!-- title, sub -->
        <div>
          <!-- title -->
          <div style="font-weight: 700; font-size: 17px; line-height: 140%; letter-spacing: -0.05em; color: #FF6A39">
            Nextrise 스타트업 아우토반 (6/26~6/27)
          </div>
          <!-- sub -->
          <div class="d-flex align-center" style="width: fit-content; gap: 2px; border-bottom: 1px solid #ffffff" @click.stop="clickTopAlert_sub()">
            <div style="font-weight: 400; font-size: 17px; line-height: 23px; letter-spacing: -0.03em; color: #ffffff">
              NextRise 공식 페이지 바로가기
            </div>
            <v-icon style="font-size: 16px; color: #ffffff">
              mdi-arrow-right
            </v-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- navbar - 로그인 전 (show-over-1025) -->
  <div v-if="!$store.getters.isLoggedIn && $route.name !== 'SignUpCorporation' && $route.name !== 'SignUpCorporation2' && $route.name !== 'LoginProsecution' && $route.name !== 'SignUpProsecution'" class="show-over-1025"
    style="position: sticky; z-index: 99; height: 60px; width: 100%; background-color: #FFFFFF; border-bottom: 1px solid #E8EAF2"
    :style="top_alert ? {top: top_alert_height} : {top: '0px'}"
  >
    <div class="d-flex align-center justify-center" style="height: 100%">
      <div v-if="fontReady" class="nav-bar d-flex align-center" style="height: 100%">
        <!-- 리컬럼 로고 -->
        <div @click="clickNavLogo()" class="d-flex align-center" style="cursor: pointer; margin-right: 24px">
          <!-- logo -->
          <img src="/assets/recolumn-logo.svg" style="width: 15px; height: 23px; object-fit: contain; margin-right: 8px">
          <!-- title -->
          <div style="font-size: 24px; font-weight: 600; line-height: 100%; color: #0D0E17; letter-spacing: -0.02em">
            Re:Column
          </div>
        </div>
        <!-- 메뉴 - 제품(dropdown), 솔루션(dropdown), 고객사례, (가격안내(dropdown)), 뉴스룸 -->
        <div class="d-flex align-center" style="gap: 2px">
          <!-- 제품(dropdown) -->
          <div>
            <v-menu offset-y open-on-hover>
              <template v-slot:activator="{ on, value }">
                <div v-on="on" class="d-flex align-center">
                  <div class="hover-bg-color d-flex align-center"
                    style="--hover-bg-color: #EFF0F6; height: 40px; border-radius: 8px; padding: 0px 10px; gap: 2px; cursor: pointer"
                  >
                    <div style="font-size: 14px; font-weight: 600; line-height: 18px; color: #0D0E17"
                      :style="$route?.name?.includes('Product') ? {color: '#687EFF'} : {color: '#0D0E17'}"
                    >
                      제품
                    </div>
                    <v-icon :class="value ? 'up' : 'down'" style="font-size: 16px; color: #ABAEC4">
                      mdi-chevron-down
                    </v-icon>
                  </div>
                </div>
              </template>
              <v-card>
                <div class="d-flex flex-column" style="width: 280px; padding: 10px 8px; gap: 6px">
                  <!-- 리컬럼 소개서 -->
                  <div @click="manualDownloadDialog = true"
                    class="hover-bg-color d-flex align-start" style="--hover-bg-color: #F8F9FB; width: 100%; border-radius: 8px; padding: 9px 12px; cursor: pointer; gap: 12px"
                  >
                    <!-- icon box -->
                    <div class="d-flex align-center justify-center" style="min-width: 42px; height: 42px; border-radius: 8px; background-color: #162050">
                      <v-icon style="font-size: 24px; color: #ffffff">
                        mdi-tray-arrow-down
                      </v-icon>
                    </div>
                    <!-- text box -->
                    <div>
                      <div style="font-size: 16px; font-weight: 600; line-height: 140%; color: #0D0E17; margin-bottom: 2px">
                        리컬럼 소개서
                      </div>
                      <div style="font-size: 14px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #414458">
                        PDF 다운로드
                      </div>
                    </div>
                  </div>
                  <!-- divider -->
                  <div style="width: 100%; height: 1px; background-color: #E8EAF2; margin: 4px 7px"></div>
                  <!-- 워크플로우 -->
                  <div @click="goProductPage('/product-workflow')"
                    class="hover-bg-color d-flex align-start" style="--hover-bg-color: #F8F9FB; width: 100%; border-radius: 8px; padding: 9px 12px; cursor: pointer; gap: 12px"
                  >
                    <!-- icon box -->
                    <div class="d-flex align-center justify-center" style="min-width: 42px; height: 42px; border-radius: 8px; background-color: #AF52DE1F">
                      <v-icon style="font-size: 24px; color: #AF52DE">
                        mdi-play-circle-outline
                      </v-icon>
                    </div>
                    <!-- text box -->
                    <div>
                      <div style="font-size: 16px; font-weight: 600; line-height: 140%; color: #0D0E17; margin-bottom: 2px">
                        워크플로우
                      </div>
                      <div style="font-size: 14px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #414458">
                        모든 반복 작업을 원클릭으로
                      </div>
                    </div>
                  </div>
                  <!-- 엑셀 서식 -->
                  <div @click="goProductPage('/product-excel-format')"
                    class="hover-bg-color d-flex align-start" style="--hover-bg-color: #F8F9FB; width: 100%; border-radius: 8px; padding: 9px 12px; cursor: pointer; gap: 12px"
                  >
                    <!-- icon box -->
                    <div class="d-flex align-center justify-center" style="min-width: 42px; height: 42px; border-radius: 8px; background-color: #5856D61F">
                      <v-icon style="font-size: 24px; color: #5856D6">
                        mdi-palette-outline
                      </v-icon>
                    </div>
                    <!-- text box -->
                    <div>
                      <div style="font-size: 16px; font-weight: 600; line-height: 140%; color: #0D0E17; margin-bottom: 2px">
                        엑셀 서식
                      </div>
                      <div style="font-size: 14px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #414458">
                        데이터 변경에 자동 대응
                      </div>
                    </div>
                  </div>
                  <!-- 시각화 대시보드 -->
                  <div @click="goProductPage('/product-visualization')"
                    class="hover-bg-color d-flex align-start" style="--hover-bg-color: #F8F9FB; width: 100%; border-radius: 8px; padding: 9px 12px; cursor: pointer; gap: 12px"
                  >
                    <!-- icon box -->
                    <div class="d-flex align-center justify-center" style="min-width: 42px; height: 42px; border-radius: 8px; background-color: #FF2D551F">
                      <v-icon style="font-size: 24px; color: #FF2D55">
                        mdi-chart-line
                      </v-icon>
                    </div>
                    <!-- text box -->
                    <div>
                      <div style="font-size: 16px; font-weight: 600; line-height: 140%; color: #0D0E17; margin-bottom: 2px">
                        시각화 대시보드
                      </div>
                      <div style="font-size: 14px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #414458">
                        자유로운 구성
                      </div>
                    </div>
                  </div>
                  <!-- 데이터 검증 -->
                  <div @click="goProductPage('/product-data-verify')"
                    class="hover-bg-color d-flex align-start" style="--hover-bg-color: #F8F9FB; width: 100%; border-radius: 8px; padding: 9px 12px; cursor: pointer; gap: 12px"
                  >
                    <!-- icon box -->
                    <div class="d-flex align-center justify-center" style="min-width: 42px; height: 42px; border-radius: 8px; background-color: #007AFF1F">
                      <v-icon style="font-size: 24px; color: #007AFF">
                        mdi-magnify
                      </v-icon>
                    </div>
                    <!-- text box -->
                    <div>
                      <div style="font-size: 16px; font-weight: 600; line-height: 140%; color: #0D0E17; margin-bottom: 2px">
                        데이터 검증
                      </div>
                      <div style="font-size: 14px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #414458">
                        두 데이터의 차이 검토
                      </div>
                    </div>
                  </div>
                  <!-- 문서 폼 -->
                  <div @click="goProductPage('/product-document-form')"
                    class="hover-bg-color d-flex align-start" style="--hover-bg-color: #F8F9FB; width: 100%; border-radius: 8px; padding: 9px 12px; cursor: pointer; gap: 12px"
                  >
                    <!-- icon box -->
                    <div class="d-flex align-center justify-center" style="min-width: 42px; height: 42px; border-radius: 8px; background-color: #00C7BE1F">
                      <v-icon style="font-size: 24px; color: #00C7BE">
                        mdi-file-outline
                      </v-icon>
                    </div>
                    <!-- text box -->
                    <div>
                      <div style="font-size: 16px; font-weight: 600; line-height: 140%; color: #0D0E17; margin-bottom: 2px">
                        문서 폼
                      </div>
                      <div style="font-size: 14px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #414458">
                        옵션 선택이 있는 폼 자동 작성
                      </div>
                    </div>
                  </div>
                  <!-- 이메일 유효성 검증 -->
                  <div @click="goProductPage('/product-email-verify')"
                    class="hover-bg-color d-flex align-start" style="--hover-bg-color: #F8F9FB; width: 100%; border-radius: 8px; padding: 9px 12px; cursor: pointer; gap: 12px"
                  >
                    <!-- icon box -->
                    <div class="d-flex align-center justify-center" style="min-width: 42px; height: 42px; border-radius: 8px; background-color: #34C7591F">
                      <v-icon style="font-size: 24px; color: #34C759">
                        mdi-at
                      </v-icon>
                    </div>
                    <!-- text box -->
                    <div>
                      <div style="font-size: 16px; font-weight: 600; line-height: 140%; color: #0D0E17; margin-bottom: 2px">
                        이메일 유효성 검증
                      </div>
                      <div style="font-size: 14px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #414458">
                        형식 및 유효성 검증
                      </div>
                    </div>
                  </div>
                  <!-- 협업 기능 -->
                  <div @click="goProductPage('/product-cooperation')"
                    class="hover-bg-color d-flex align-start" style="--hover-bg-color: #F8F9FB; width: 100%; border-radius: 8px; padding: 9px 12px; cursor: pointer; gap: 12px"
                  >
                    <!-- icon box -->
                    <div class="d-flex align-center justify-center" style="min-width: 42px; height: 42px; border-radius: 8px; background-color: #FF95001F">
                      <v-icon style="font-size: 24px; color: #FF9500">
                        mdi-account-multiple
                      </v-icon>
                    </div>
                    <!-- text box -->
                    <div>
                      <div style="font-size: 16px; font-weight: 600; line-height: 140%; color: #0D0E17; margin-bottom: 2px">
                        협업 기능
                      </div>
                      <div style="font-size: 14px; font-weight: 400; line-height: 140%; letter-spacing: -0.02em; color: #414458">
                        작업 내역 및 소통
                      </div>
                    </div>
                  </div>
                </div>
              </v-card>
            </v-menu>
          </div>
          <!-- 솔루션(dropdown) -->
          <div>
            <v-menu offset-y open-on-hover>
              <template v-slot:activator="{ on, value }">
                <div v-on="on" class="d-flex align-center">
                  <div class="hover-bg-color d-flex align-center"
                    style="--hover-bg-color: #EFF0F6; height: 40px; border-radius: 8px; padding: 0px 10px; gap: 2px; cursor: pointer"
                  >
                    <div style="font-size: 14px; font-weight: 600; line-height: 18px; color: #0D0E17"
                      :style="$route?.name?.includes('Solution') ? {color: '#687EFF'} : {color: '#0D0E17'}"
                    >
                      솔루션
                    </div>
                    <v-icon :class="value ? 'up' : 'down'" style="font-size: 16px; color: #ABAEC4">
                      mdi-chevron-down
                    </v-icon>
                  </div>
                </div>
              </template>
              <v-card>
                <div class="d-flex flex-column" style="width: 280px; padding: 10px 8px; gap: 6px">
                  <!-- 이커머스 -->
                  <div @click="goSolutionPage('/solution-ecommerce')"
                    class="hover-bg-color d-flex align-center" style="--hover-bg-color: #F8F9FB; width: 100%; border-radius: 8px; padding: 9px 12px; cursor: pointer; gap: 12px"
                  >
                    <!-- icon box -->
                    <div class="d-flex align-center justify-center" style="min-width: 42px; height: 42px; border-radius: 8px; background-color: #EFF0F6">
                      <v-icon style="font-size: 24px; color: #414458">
                        mdi-shopping
                      </v-icon>
                    </div>
                    <!-- text -->
                    <div style="font-size: 16px; font-weight: 500; line-height: 140%; color: #0D0E17">
                      이커머스
                    </div>
                  </div>
                  <!-- 유통 ∙ 물류 -->
                  <div @click="goSolutionPage('/solution-logistics')"
                    class="hover-bg-color d-flex align-center" style="--hover-bg-color: #F8F9FB; width: 100%; border-radius: 8px; padding: 9px 12px; cursor: pointer; gap: 12px"
                  >
                    <!-- icon box -->
                    <div class="d-flex align-center justify-center" style="min-width: 42px; height: 42px; border-radius: 8px; background-color: #162050">
                      <v-icon style="font-size: 24px; color: #FFFFFF">
                        mdi-truck-fast
                      </v-icon>
                    </div>
                    <!-- text -->
                    <div style="font-size: 16px; font-weight: 500; line-height: 140%; color: #0D0E17">
                      유통 ∙ 물류
                    </div>
                  </div>
                </div>
              </v-card>
            </v-menu>
          </div>
          <!-- 고객사례 -->
          <div @click="goCustomerExample()"
            class="hover-bg-color d-flex align-center"
            style="--hover-bg-color: #EFF0F6; height: 40px; border-radius: 8px; padding: 0px 10px; cursor: pointer; font-size: 14px; font-weight: 600; line-height: 18px"
            :style="$route.name === 'CustomerExample' || $route.name === 'CustomerExampleDetail' ? {color: '#687EFF'} : {color: '#0D0E17'}"
          >
            고객사례
          </div>
          <!-- 가격안내(dropdown) -->
          <div v-if="false">
            <v-menu offset-y open-on-hover>
              <template v-slot:activator="{ on, value }">
                <div v-on="on" class="d-flex align-center">
                  <div class="hover-bg-color d-flex align-center"
                    style="--hover-bg-color: #EFF0F6; height: 40px; border-radius: 8px; padding: 0px 10px; gap: 2px; cursor: pointer"
                  >
                    <div style="font-size: 14px; font-weight: 600; line-height: 18px"
                      :style="$route.name === 'PlanGuide' || $route.name === 'Voucher' ? {color: '#687EFF'} : {color: '#0D0E17'}"
                    >
                      가격안내
                    </div>
                    <v-icon :class="value ? 'up' : 'down'" style="font-size: 16px; color: #ABAEC4">
                      mdi-chevron-down
                    </v-icon>
                  </div>
                </div>
              </template>
              <v-card>
                <div class="d-flex flex-column" style="width: 280px; padding: 10px 8px; gap: 6px">
                  <!-- 플랜 안내 -->
                  <div @click="goPlanGuide()"
                    class="hover-bg-color-F8F9FB d-flex align-start" style="width: 100%; border-radius: 8px; padding: 9px 12px; cursor: pointer; gap: 12px"
                  >
                    <!-- icon box -->
                    <div class="d-flex align-center justify-center" style="min-width: 42px; height: 42px; border-radius: 8px; background-color: #EFF0F6">
                      <v-icon style="font-size: 24px; color: #414458">
                        mdi-currency-usd
                      </v-icon>
                    </div>
                    <!-- text box -->
                    <div>
                      <div style="font-size: 16px; font-weight: 600; line-height: 140%; color: #0D0E17; margin-bottom: 2px">
                        플랜 안내
                      </div>
                      <div style="font-size: 14px; font-weight: 400; line-height: 140%; color: #414458">
                        가장 적합한 플랜을 선택하세요
                      </div>
                    </div>
                  </div>
                  <!-- 바우처 -->
                  <div @click="goVoucher()"
                    class="hover-bg-color-F8F9FB d-flex align-start" style="width: 100%; border-radius: 8px; padding: 9px 12px; cursor: pointer; gap: 12px"
                  >
                    <!-- icon box -->
                    <div class="d-flex align-center justify-center" style="min-width: 42px; height: 42px; border-radius: 8px; background-color: #EFF0F6">
                      <v-icon style="font-size: 24px; color: #414458">
                        mdi-ticket-percent-outline
                      </v-icon>
                    </div>
                    <!-- text box -->
                    <div>
                      <div style="font-size: 16px; font-weight: 600; line-height: 140%; color: #0D0E17; margin-bottom: 2px">
                        바우처
                      </div>
                      <div style="font-size: 14px; font-weight: 400; line-height: 140%; color: #414458">
                        도입 비용 70% 할인
                      </div>
                    </div>
                  </div>
                </div>
              </v-card>
            </v-menu>
          </div>
          <!-- 뉴스룸 -->
          <div @click="goNewsRoom()"
            class="hover-bg-color d-flex align-center"
            style="--hover-bg-color: #EFF0F6; height: 40px; border-radius: 8px; padding: 0px 10px; cursor: pointer; font-size: 14px; font-weight: 600; line-height: 18px"
            :style="$route.name === 'NewsRoom' || $route.name === 'NewsRoomDetail' ? {color: '#687EFF'} : {color: '#0D0E17'}"
          >
            뉴스룸
          </div>
        </div>
        <v-spacer></v-spacer>
        <!-- 연락처, 로그인 버튼, (2주 무료체험 버튼), 문의하기 버튼 -->
        <div class="d-flex align-center" style="gap: 8px">
          <!-- 연락처 -->
          <div class="d-flex align-center" style="height: 40px; padding: 0px 10px; gap: 4px">
            <v-icon style="font-size: 18px; color: #414458">
              mdi-phone
            </v-icon>
            <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
              02-2088-2096
            </div>
          </div>
          <!-- 로그인 버튼 -->
          <div @click="openLoginDialog()"
            class="default-transparent-btn-2 d-flex align-center"
            style="height: 40px; padding: 0px 16px"
          >
            <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
              로그인
            </div>
          </div>
          <!-- 도입 문의하기 버튼 -->
          <div @click="clickContactBtn()"
            class="hover-icon-slide-btn-2px d-flex align-center justify-center"
            style="height: 40px; padding: 0px 12px 0px 16px; background-color: #162050; border-radius: 4px; gap: 4px; cursor: pointer"
          >
            <div style="font-size: 14px; font-weight: 600; line-height: 18px; color: #FFFFFF">
              도입 문의하기
            </div>
            <v-icon style="font-size: 16px; color: #FFFFFF">
              mdi-arrow-right
            </v-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- navbar - 로그인 전 (show-under-1024) -->
  <div v-if="fontReady && !$store.getters.isLoggedIn && $route.name !== 'SignUpCorporation' && $route.name !== 'SignUpCorporation2' && $route.name !== 'LoginProsecution' && $route.name !== 'SignUpProsecution'" class="show-under-1024"
    style="position: sticky; z-index: 99; height: 60px; width: 100%; background-color: #FFFFFF; border-bottom: 1px solid #E8EAF2"
    :style="top_alert ? {top: top_alert_height} : {top: '0px'}"
  >
    <div class="d-flex align-center justify-center" style="height: 100%">
      <div class="nav-bar d-flex align-center" style="height: 100%">
        <!-- 리컬럼 로고 -->
        <div @click="clickNavLogo(); isShowHamburgerMenu = false" class="d-flex align-center" style="gap: 8px; cursor: pointer">
          <!-- logo -->
          <img src="/assets/recolumn-logo.svg" style="width: 15px; height: 23px; object-fit: contain">
          <!-- title -->
          <div style="font-size: 24px; font-weight: 600; line-height: 100%; color: #0D0E17; letter-spacing: -0.02em">
            Re:Column
          </div>
        </div>
        <v-spacer></v-spacer>
        <!-- 메뉴 버튼 (햄버거) -->
        <div @click="isShowHamburgerMenu = !isShowHamburgerMenu"
          class="default-icon-btn d-flex align-center justify-center"
          style="width: 44px; height: 44px"
        >
          <v-icon style="font-size: 28px">
            mdi-menu
          </v-icon>
        </div>
        <!-- 메뉴 -->
        <div v-if="isShowHamburgerMenu"
          style="position: fixed; left: 0px; width: 100vw; height: calc(100vh - 60px); background-color: #ffffff"
          :style="top_alert ? {top: `calc(${top_alert_height} + 60px)`} : {top: '60px'}"
        >
          <!-- 메뉴 - 제품, 솔루션, 고객사례, (가격안내), 뉴스룸 -->
          <div class="d-flex flex-wrap align-start justify-start" style="gap: 40px 20px; width: 100%; padding: 20px 24px">
            <!-- 제품 -->
            <div style="min-width: 120px">
              <!-- title -->
              <div style="padding-left: 12px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #ABAEC4">
                제품
              </div>
              <!-- 리컬럼 소개서 -->
              <div @click="manualDownloadDialog = true; isShowHamburgerMenu = false"
                class="hover-bg-color-EFF0F6 d-flex align-center" style="height: 40px; width: fit-content; border-radius: 4px; padding: 0px 12px; cursor: pointer"
              >
                <div style="font-weight: 600; font-size: 15px; line-height: 145%; letter-spacing: -0.02em; color: #414458">
                  리컬럼 소개서
                </div>
              </div>
              <!-- 워크플로우 -->
              <div @click="goProductPage('/product-workflow'); isShowHamburgerMenu = false"
                class="hover-bg-color-EFF0F6 d-flex align-center" style="height: 40px; width: fit-content; border-radius: 4px; padding: 0px 12px; cursor: pointer"
              >
                <div style="font-weight: 600; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                  :style="$route.name === 'ProductWorkflow' ? {color: '#687EFF'} : {color: '#414458'}"
                >
                  워크플로우
                </div>
              </div>
              <!-- 엑셀 서식 -->
              <div @click="goProductPage('/product-excel-format'); isShowHamburgerMenu = false"
                class="hover-bg-color-EFF0F6 d-flex align-center" style="height: 40px; width: fit-content; border-radius: 4px; padding: 0px 12px; cursor: pointer"
              >
                <div style="font-weight: 600; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                  :style="$route.name === 'ProductExcelFormat' ? {color: '#687EFF'} : {color: '#414458'}"
                >
                  엑셀 서식
                </div>
              </div>
              <!-- 시각화 대시보드 -->
              <div @click="goProductPage('/product-visualization'); isShowHamburgerMenu = false"
                class="hover-bg-color-EFF0F6 d-flex align-center" style="height: 40px; width: fit-content; border-radius: 4px; padding: 0px 12px; cursor: pointer"
              >
                <div style="font-weight: 600; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                  :style="$route.name === 'ProductVisualization' ? {color: '#687EFF'} : {color: '#414458'}"
                >
                  시각화 대시보드
                </div>
              </div>
              <!-- 데이터 검증 -->
              <div @click="goProductPage('/product-data-verify'); isShowHamburgerMenu = false"
                class="hover-bg-color-EFF0F6 d-flex align-center" style="height: 40px; width: fit-content; border-radius: 4px; padding: 0px 12px; cursor: pointer"
              >
                <div style="font-weight: 600; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                  :style="$route.name === 'ProductDataVerify' ? {color: '#687EFF'} : {color: '#414458'}"
                >
                  데이터 검증
                </div>
              </div>
              <!-- 문서 폼 -->
              <div @click="goProductPage('/product-document-form'); isShowHamburgerMenu = false"
                class="hover-bg-color-EFF0F6 d-flex align-center" style="height: 40px; width: fit-content; border-radius: 4px; padding: 0px 12px; cursor: pointer"
              >
                <div style="font-weight: 600; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                  :style="$route.name === 'ProductDocumentForm' ? {color: '#687EFF'} : {color: '#414458'}"
                >
                  문서 폼
                </div>
              </div>
              <!-- 이메일 유효성 검증 -->
              <div @click="goProductPage('/product-email-verify'); isShowHamburgerMenu = false"
                class="hover-bg-color-EFF0F6 d-flex align-center" style="height: 40px; width: fit-content; border-radius: 4px; padding: 0px 12px; cursor: pointer"
              >
                <div style="font-weight: 600; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                  :style="$route.name === 'ProductEmailVerify' ? {color: '#687EFF'} : {color: '#414458'}"
                >
                  이메일 유효성 검증
                </div>
              </div>
              <!-- 협업 기능 -->
              <div @click="goProductPage('/product-cooperation'); isShowHamburgerMenu = false"
                class="hover-bg-color-EFF0F6 d-flex align-center" style="height: 40px; width: fit-content; border-radius: 4px; padding: 0px 12px; cursor: pointer"
              >
                <div style="font-weight: 600; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                  :style="$route.name === 'ProductCooperation' ? {color: '#687EFF'} : {color: '#414458'}"
                >
                  협업 기능
                </div>
              </div>
            </div>
            <!-- 솔루션 -->
            <div style="min-width: 120px">
              <!-- title -->
              <div style="padding-left: 12px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #ABAEC4">
                솔루션
              </div>
              <!-- 이커머스 -->
              <div @click="goSolutionPage('/solution-ecommerce'); isShowHamburgerMenu = false"
                class="hover-bg-color-EFF0F6 d-flex align-center" style="height: 40px; width: fit-content; border-radius: 4px; padding: 0px 12px; cursor: pointer"
              >
                <div style="font-weight: 600; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                  :style="$route.name === 'SolutionEcommerce' ? {color: '#687EFF'} : {color: '#414458'}"
                >
                  이커머스
                </div>
              </div>
              <!-- 유통 ∙ 물류 -->
              <div @click="goSolutionPage('/solution-logistics'); isShowHamburgerMenu = false"
                class="hover-bg-color-EFF0F6 d-flex align-center" style="height: 40px; width: fit-content; border-radius: 4px; padding: 0px 12px; cursor: pointer"
              >
                <div style="font-weight: 600; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                  :style="$route.name === 'SolutionLogistics' ? {color: '#687EFF'} : {color: '#414458'}"
                >
                  유통 ∙ 물류
                </div>
              </div>
            </div>
            <!-- 고객사례 -->
            <div style="min-width: 120px">
              <!-- title -->
              <div style="padding-left: 12px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #ABAEC4">
                고객사례
              </div>
              <!-- 고객사례 -->
              <div @click="goCustomerExample(); isShowHamburgerMenu = false"
                class="hover-bg-color-EFF0F6 d-flex align-center" style="height: 40px; width: fit-content; border-radius: 4px; padding: 0px 12px; cursor: pointer"
              >
                <div style="font-weight: 600; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                  :style="$route.name === 'CustomerExample' || $route.name === 'CustomerExampleDetail' ? {color: '#687EFF'} : {color: '#414458'}"
                >
                  고객사례
                </div>
              </div>
            </div>
            <!-- 가격안내 -->
            <div v-if="false" style="min-width: 120px">
              <!-- title -->
              <div style="padding-left: 12px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #ABAEC4">
                가격안내
              </div>
              <!-- 플랜안내 -->
              <div @click="goPlanGuide(); isShowHamburgerMenu = false"
                class="hover-bg-color-EFF0F6 d-flex align-center" style="height: 40px; width: fit-content; border-radius: 4px; padding: 0px 12px; cursor: pointer"
              >
                <div style="font-weight: 600; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                  :style="$route.name === 'PlanGuide' ? {color: '#687EFF'} : {color: '#414458'}"
                >
                  플랜안내
                </div>
              </div>
              <!-- 바우처 -->
              <div @click="goVoucher(); isShowHamburgerMenu = false"
                class="hover-bg-color-EFF0F6 d-flex align-center" style="height: 40px; width: fit-content; border-radius: 4px; padding: 0px 12px; cursor: pointer"
              >
                <div style="font-weight: 600; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                  :style="$route.name === 'Voucher' ? {color: '#687EFF'} : {color: '#414458'}"
                >
                  바우처
                </div>
              </div>
            </div>
            <!-- 뉴스룸 -->
            <div style="min-width: 120px">
              <!-- title -->
              <div style="padding-left: 12px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #ABAEC4">
                뉴스룸
              </div>
              <!-- 뉴스룸 -->
              <div @click="goNewsRoom(); isShowHamburgerMenu = false"
                class="hover-bg-color-EFF0F6 d-flex align-center" style="height: 40px; width: fit-content; border-radius: 4px; padding: 0px 12px; cursor: pointer"
              >
                <div style="font-weight: 600; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                  :style="$route.name === 'NewsRoom' || $route.name === 'NewsRoomDetail' ? {color: '#687EFF'} : {color: '#414458'}"
                >
                  뉴스룸
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 기한 만료 알림 alert - 로그인 후 -->
  <div v-if="expireDateEndAlert && $store.getters.isLoggedIn" class="d-flex align-center" style="position: sticky; top: 0px; z-index: 99; width: 100%; height: 44px; background-color: #414458">
    <div style="width: calc(32px + 6px)"></div>
    <v-spacer></v-spacer>
    <v-icon style="font-size: 20px; color: #ffffff; margin-right: 4px">
      mdi-alert-circle-outline
    </v-icon>
    <!-- 무료체험 -->
    <div v-if="$store.state.user_info.plan === 'trial'" style="font-size: 14px; font-weight: 700; line-height: 20px; color: #ffffff; margin-right: 16px">
      리컬럼 무료체험이 종료되었습니다. 종료 일자로부터 7일간 읽기 전용 모드가 제공됩니다. (~{{ $store.state.user_info.paid_expire_date | paidExpireDateFilter }})
    </div>
    <!-- 엔터프라이즈 -->
    <div v-else style="font-size: 14px; font-weight: 700; line-height: 20px; color: #ffffff; margin-right: 16px">
      플랜 사용 기한이 만료되어 사용할 수 있는 기능이 제한됩니다. 조직의 결제 담당자 혹은 리컬럼 관리자에게 문의해 주세요.
    </div>
    <!-- 도입 문의하기 버튼 (무료체험) -->
    <div v-if="$store.state.user_info.plan === 'trial'" @click="contactDialog = true"
      class="default-transparent-btn-3 d-flex align-center" style="height: 30px; border-radius: 8px; border: 1px solid #ffffff; padding: 0px 12px; cursor: pointer"
    >
      <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #ffffff">
        도입 문의하기
      </div>
    </div>
    <!-- 관리자에게 문의 버튼 (엔터프라이즈) -->
    <div v-else @click="clickContactAdminBtn()"
      class="default-transparent-btn-3 d-flex align-center" style="height: 30px; border-radius: 8px; border: 1px solid #ffffff; padding: 0px 12px; cursor: pointer"
    >
      <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #ffffff">
        관리자에게 문의
      </div>
    </div>
    <v-spacer></v-spacer>
    <div @click="expireDateEndAlert = false"
      class="default-icon-btn-dark d-flex align-center justify-center"
      style="width: 32px; height: 32px; margin-right: 6px"
    >
      <v-icon style="font-size: 20px">
        mdi-close
      </v-icon>
    </div>
  </div>
  <!-- navbar - 로그인 후 -->
  <div v-if="fontReady && $store.getters.isLoggedIn && $route.name !== 'SignUpCorporation' && $route.name !== 'SignUpCorporation2'"
    class="d-flex align-center"
    :class="expireDateEndAlert ? 'top-48' : 'top-0'"
    style="position: sticky; z-index: 99; min-height: 48px; width: 100%; min-width: 1536px; border-bottom: 1px solid #E8EAF2"
    :style="$route.name === 'TotalTrashCan' ? {padding: '0px 120px 0px 120px', backgroundColor: '#ffffff'} : {padding: '0px 20px 0px 20px', backgroundColor: '#F8F9FB'}"
  >
    <!-- 리컬럼 로고 -->
    <div @click="clickNavLogo()" @mousedown.middle.prevent="middleClickNavLogo()"
      class="d-flex align-center" style="gap: 6.29px; cursor: pointer"
    >
      <!-- logo -->
      <img src="/assets/recolumn-logo.svg" style="width: 11.79px; height: 18.07px; object-fit: contain">
      <!-- title -->
      <div style="font-size: 18.86px; font-weight: 600; line-height: 100%; color: #0D0E17; letter-spacing: -0.02em">
        Re:Column
      </div>
    </div>
    <!-- 메뉴 (워크스페이스, 팀 관리, 내 휴지통, 어드민 메뉴) -->
    <div v-if="($route.name === 'WorkSpace' || $route.name === 'TeamManagement' || $route.name === 'TotalTrashCan' || $route.name === 'AdminMenu')"
      class="d-flex align-center" style="position: absolute; left: 50%; transform: translateX(-50%); height: 100%; gap: 4px"
    >
      <!-- 워크스페이스 -->
      <div @click="clickMenu('WorkSpace', '/workspace')"
        class="hover-bg-color-important d-flex align-center justify-center"
        style="--hover-bg-color: #EFF0F6; height: 40px; padding: 0px 12px; border-radius: 999px; cursor: pointer"
        :style="$route.name === 'WorkSpace' ? {backgroundColor: '#EFF0F6'} : {backgroundColor: 'transparent'}"
      >
        <div style="font-size: 14px; font-weight: 500; line-height: 20px"
          :style="$route.name === 'WorkSpace' ? {color: '#414458'} : {color: '#ABAEC4'}"
        >
          {{ $t('workspace') }}
        </div>
      </div>
      <!-- 팀 관리 -->
      <div @click="clickMenu('TeamManagement', '/team-management')"
        class="hover-bg-color-important d-flex align-center justify-center"
        style="--hover-bg-color: #EFF0F6; height: 40px; padding: 0px 12px; border-radius: 999px; cursor: pointer"
        :style="$route.name === 'TeamManagement' ? {backgroundColor: '#EFF0F6'} : {backgroundColor: 'transparent'}"
      >
        <div style="font-size: 14px; font-weight: 500; line-height: 20px"
          :style="$route.name === 'TeamManagement' ? {color: '#414458'} : {color: '#ABAEC4'}"
        >
          {{ $t('teams') }}
        </div>
      </div>
      <!-- 내 휴지통 -->
      <div @click="clickMenu('TotalTrashCan', '/total-trash-can')"
        class="hover-bg-color-important d-flex align-center justify-center"
        style="--hover-bg-color: #EFF0F6; height: 40px; padding: 0px 12px; border-radius: 999px; cursor: pointer"
        :style="$route.name === 'TotalTrashCan' ? {backgroundColor: '#EFF0F6'} : {backgroundColor: 'transparent'}"
      >
        <div style="font-size: 14px; font-weight: 500; line-height: 20px"
          :style="$route.name === 'TotalTrashCan' ? {color: '#414458'} : {color: '#ABAEC4'}"
        >
          {{ $t('deleted') }}
        </div>
      </div>
      <!-- 리드 관리 (어드민 메뉴) -->
      <div v-if="$store.state.user_info.organization_permission === 'super_admin'" @click="clickMenu('AdminMenu', '/admin-menu')"
        class="hover-bg-color-important d-flex align-center justify-center"
        style="--hover-bg-color: #EFF0F6; height: 40px; padding: 0px 12px; border-radius: 999px; cursor: pointer; position: relative"
        :style="$route.name === 'AdminMenu' ? {backgroundColor: '#EFF0F6'} : {backgroundColor: 'transparent'}"
      >
        <div style="font-size: 14px; font-weight: 500; line-height: 20px"
          :style="$route.name === 'AdminMenu' ? {color: '#414458'} : {color: '#ABAEC4'}"
        >
          <!-- {{ $t('admin') }} -->
          {{ $t('lead') }}
        </div>
        <!-- 알림 뱃지 -->
        <div class="d-flex align-center justify-center"
          style="position: absolute; top: 4px; right: 4px; height: 12px; width: fit-content; border-radius: 999px; padding: 0px 3.5px; background-color: #FF3B30"
        >
          <div style="font-size: 10px; font-weight: 700; line-height: 12px; color: #ffffff">
            {{ lead_badge_cnt > 99 ? '99+' : lead_badge_cnt }}
          </div>
        </div>
      </div>
    </div>
    <!-- 프로젝트 dropdown (프로젝트 내부) -->
    <div v-if="mainRouter" class="d-flex align-center">
      <div style="height: 14px; width: 1px; background-color: #ABAEC4; margin: 0px 2px 0px 10px"></div>
      <v-menu v-model="projectDropdownMenu" offset-y bottom :close-on-content-click="false" max-width="320px">
        <!-- menu header -->
        <template v-slot:activator="{ on, value }">
          <div v-on="on" @click="value ? '' : getProjectListSimple()"
            class="hover-bg-color d-flex align-center" style="--hover-bg-color: #EFF0F6; height: 34px; padding: 0px 8px; border-radius: 8px; gap: 4px; cursor: pointer"
          >
            <!-- 로고 -->
            <div style="width: 24px; height: 24px; position: relative">
              <img style="width: 24px; height: 24px; object-fit: contain"
                :src="$store.state.current_project.icon_url ? $store.state.current_project.icon_url : `/assets/project_img/${$store.state.defaultPjtImg}.svg`"
              >
              <!-- 즐겨찾기 표시 -->
              <!-- <img v-if="$store.state.current_project.favorite" src="/assets/star.svg" style="position: absolute; bottom: -6px; right: -6px; width: 20px; height: 20px; object-fit: contain"> -->
            </div>
            <!-- 프로젝트 이름 -->
            <div style="font-size: 14px; font-weight: 400; line-height: 18px; color: #414458">
              {{ $store.state.current_project.name }}
            </div>
            <!-- expand icon -->
            <v-icon :class="value ? 'up' : 'down'" style="font-size: 18px; color: #ABAEC4">
              mdi-chevron-down
            </v-icon>
          </div>
        </template>
        <!-- 프로젝트 검색창 및 목록 -->
        <v-card style="max-height: 620px; width: 320px; overflow: hidden auto; position: relative">
          <!-- 프로젝트 검색창 -->
          <div style="position: sticky; top: 0px; z-index: 1; width: 100%; padding: 10px; background-color: #ffffff">
            <v-text-field v-if="!isSearchingPjt" ref="searchPjtNameInput" v-click-outside="clickOutsidePjtSearchInput"
              v-model="searchPjtNameInput" placeholder="프로젝트 검색하기"
              prepend-inner-icon="mdi-magnify" @click:prepend-inner="searchProject(searchPjtNameInput, 'drawer')"
              height="40px" background-color="#F8F9FB" color="#0D0E17" outlined dense hide-details
              class="search-input-40" style="border-radius: 8px; font-size: 14px"
              @keyup.enter="searchProject(searchPjtNameInput, 'drawer')"
            ></v-text-field>
            <div v-else @click="clickSearchedChip()"
              class="d-flex align-center"
              style="height: 40px; width: 100%; background-color: #F0F2FF; border-radius: 8px; padding-left: 14px; padding-right: 14px; cursor: pointer"
            >
              <v-icon style="font-size: 24px; color: #687EFF; margin-right: 4px">
                mdi-magnify
              </v-icon>
              <div style="font-size: 14px; font-weight: 600; color: #687EFF">
                {{ searchPjtNameInput }}
              </div>
              <v-spacer></v-spacer>
              <div @click="clearSearchInput('drawer')"
                class="default-theme-icon-btn d-flex align-center justify-center"
                style="width: 32px; height: 32px"
              >
                <v-icon style="font-size: 20px">mdi-close</v-icon>
              </div>
            </div>
          </div>
          <!-- loading -->
          <div v-if="loadingProjectList" class="d-flex align-center justify-center py-4" style="height: 100%">
            <v-progress-circular
              :size="40"
              color="#687EFF"
              indeterminate
            ></v-progress-circular>
          </div>
          <!-- 목록 -->
          <div v-else class="d-flex flex-column" style="gap: 4px; padding: 0px 10px 10px 10px">
            <div v-for="project_item in projectList" :key="project_item.pk">
              <div @click="clickProjectItem(project_item)"
                class="project-item d-flex align-center" style="height: 52px; width: 100%; border-radius: 8px; padding: 8px; cursor: pointer"
                :style="project_item.pk === $store.state.current_project_pk ? {backgroundColor: '#EFF0F6'} : {}"
              >
                <!-- 로고 -->
                <div style="width: 36px; height: 36px; position: relative">
                  <img style="width: 36px; height: 36px; object-fit: contain; border-radius: 5.68px; border: 1px solid #E8EAF2"
                    :src="project_item.icon_url ? project_item.icon_url : `/assets/project_img/${$store.state.defaultPjtImg}.svg`"
                  >
                  <!-- 즐겨찾기 표시 -->
                  <img v-if="project_item.favorite" src="/assets/star.svg" style="position: absolute; bottom: -6px; right: -6px; width: 20px; height: 20px; object-fit: contain">
                </div>
                <!-- 프로젝트 이름 / 권한 및 일시 -->
                <div class="d-flex flex-column align-start justify-space-between" style="width: calc(100% - 36px); height: 34px; margin-left: 8px">
                  <!-- 프로젝트 이름 -->
                  <div style="font-size: 14px; font-weight: 600; line-height: 18px; color: #101010; width: 100%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                    {{ project_item.name }}
                  </div>
                  <!-- 권한 및 일시 -->
                  <div style="font-size: 12px; font-weight: 400; line-height: 14px; color: #8A8DA8">
                    {{ project_item.level | permissionFilter }} • 
                    {{ projectListOrder.includes('updated_at') ? project_item.updated_at : project_item.created_at | dateFormatFilter }}, 
                    {{ projectListOrder.includes('updated_at') ? project_item.updated_at : project_item.created_at | timeFormatFilter }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-card>
      </v-menu>
    </div>
    <!-- 워크플로우 dropdown (워크플로우 설계창) -->
    <div v-if="$route.name === 'RpaMain2' || $route.name === 'RpaMain3'" class="d-flex align-center">
      <div style="height: 14px; width: 1px; background-color: #ABAEC4; margin: 0px 2px"></div>
      <v-menu v-model="workflowDropdownMenu" offset-y bottom :close-on-content-click="false" max-width="320px">
        <!-- menu header -->
        <template v-slot:activator="{ on, value }">
          <div v-on="on" @click="value ? '' : getRpaList($store.state.current_project_pk)"
            class="hover-bg-color d-flex align-center" style="--hover-bg-color: #EFF0F6; height: 34px; padding: 0px 8px; border-radius: 8px; gap: 4px; cursor: pointer"
          >
            <!-- 워크플로우 메뉴 아이콘 -->
            <div class="d-flex align-center justify-center" style="min-width: 24px; height: 24px">
              <img :src="`/assets/menu_icon/rpa2_off.svg`" style="width: 16px; height: 16px">
            </div>
            <!-- 워크플로우 제목 -->
            <div style="font-size: 14px; font-weight: 400; line-height: 18px; color: #414458">
              {{ $store?.state?.current_rpa?.name }}
            </div>
            <!-- expand icon -->
            <v-icon :class="value ? 'up' : 'down'" style="font-size: 18px; color: #ABAEC4">
              mdi-chevron-down
            </v-icon>
          </div>
        </template>
        <!-- 워크플로우 검색창 및 목록 -->
        <v-card style="max-height: 620px; width: 320px; overflow: hidden auto; position: relative">
          <!-- 워크플로우 검색창 -->
          <div style="position: sticky; top: 0px; z-index: 1; width: 100%; padding: 10px; background-color: #ffffff">
            <v-text-field v-if="!isSearchingWorkflow" ref="searchWorkflowNameInput" v-click-outside="clickOutsideWorkflowSearchInput"
              v-model="searchWorkflowNameInput" placeholder="워크플로우 검색하기"
              prepend-inner-icon="mdi-magnify" @click:prepend-inner="searchWorkflow(searchWorkflowNameInput)"
              height="40px" background-color="#F8F9FB" color="#0D0E17" outlined dense hide-details
              class="search-input-40" style="border-radius: 8px; font-size: 14px"
              @keyup.enter="searchWorkflow(searchWorkflowNameInput)"
            ></v-text-field>
            <div v-else @click="clickSearchedChip2()"
              class="d-flex align-center"
              style="height: 40px; width: 100%; background-color: #F0F2FF; border-radius: 8px; padding-left: 14px; padding-right: 14px; cursor: pointer"
            >
              <v-icon style="font-size: 24px; color: #687EFF; margin-right: 4px">
                mdi-magnify
              </v-icon>
              <div style="font-size: 14px; font-weight: 600; color: #687EFF">
                {{ searchWorkflowNameInput }}
              </div>
              <v-spacer></v-spacer>
              <div @click="clearSearchInput2()"
                class="default-theme-icon-btn d-flex align-center justify-center"
                style="width: 32px; height: 32px"
              >
                <v-icon style="font-size: 20px">mdi-close</v-icon>
              </div>
            </div>
          </div>
          <!-- loading -->
          <div v-if="loadingWorkflowList" class="d-flex align-center justify-center py-4" style="height: 100%">
            <v-progress-circular
              :size="40"
              color="#687EFF"
              indeterminate
            ></v-progress-circular>
          </div>
          <!-- 목록 -->
          <div v-else class="d-flex flex-column" style="gap: 4px; padding: 0px 10px 10px 10px">
            <div v-for="workflow_item in workflowList" :key="workflow_item.id">
              <div @click="clickWorkflowItem(workflow_item)"
                class="hover-bg-color d-flex align-center" style="--hover-bg-color: #F8F9FB; height: 52px; width: 100%; border-radius: 8px; padding: 8px; cursor: pointer"
                :style="workflow_item.id === $store.state.current_rpa.id ? {backgroundColor: '#EFF0F6'} : {}"
              >
                <!-- 워크플로우 이름 / 일시 및 실행횟수 -->
                <div class="d-flex flex-column align-start justify-space-between" style="height: 34px; width: 100%; margin-left: 8px">
                  <!-- 워크플로우 이름 -->
                  <div style="font-size: 14px; font-weight: 600; line-height: 18px; color: #101010; width: 100%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                    {{ workflow_item.name }}
                  </div>
                  <!-- 일시 및 실행횟수 -->
                  <div style="font-size: 12px; font-weight: 400; line-height: 14px; color: #8A8DA8">
                    {{ workflow_item.created_at | dateFormatFilter }}, 
                    {{ workflow_item.created_at | timeFormatFilter }}
                      • 실행횟수 {{ workflow_item.cnt }}회
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-card>
      </v-menu>
    </div>
    <!-- 인사이트 dropdown (인사이트) -->
    <div v-if="$route.name === 'Insight2'" class="d-flex align-center">
      <div style="height: 14px; width: 1px; background-color: #ABAEC4; margin: 0px 2px"></div>
      <v-menu v-model="insightDropdownMenu" offset-y bottom :close-on-content-click="false" max-width="300px">
        <!-- menu header -->
        <template v-slot:activator="{ on, value }">
          <div v-on="on" @click="value ? '' : getInsightList()"
            class="hover-bg-color d-flex align-center" style="--hover-bg-color: #EFF0F6; height: 34px; padding: 0px 8px; border-radius: 8px; gap: 4px; cursor: pointer"
          >
            <!-- 인사이트/폴더 메뉴 아이콘 -->
            <div class="d-flex align-center justify-center" style="min-width: 24px; height: 24px">
              <v-icon v-if="!$route.params.insight_pk && $store.state.current_insight_folder" style="font-size: 16px; color: #162050">mdi-folder</v-icon>
              <img v-else :src="`/assets/menu_icon/insight_off.svg`" style="width: 16px; height: 16px">
            </div>
            <!-- 인사이트/폴더 제목 -->
            <div style="font-size: 14px; font-weight: 400; line-height: 18px; color: #414458">
              {{ !$route.params.insight_pk && $store.state.current_insight_folder ? $store.state.current_insight_folder.name : $store?.state?.current_insight?.name }}
            </div>
            <!-- expand icon -->
            <v-icon :class="value ? 'up' : 'down'" style="font-size: 18px; color: #ABAEC4">
              mdi-chevron-down
            </v-icon>
          </div>
        </template>
        <!-- 인사이트 검색창 및 목록 -->
        <v-card style="max-height: 620px; width: 300px; overflow: hidden auto; position: relative">
          <!-- 인사이트 검색창 -->
          <div style="position: sticky; top: 0px; z-index: 1; width: 100%; padding: 10px; background-color: #ffffff">
            <v-text-field v-if="!isSearchingInsight" ref="searchInsightNameInput" v-click-outside="clickOutsideInsightSearchInput"
              v-model="searchInsightNameInput" placeholder="대시보드 이름 검색하기"
              prepend-inner-icon="mdi-magnify" @click:prepend-inner="searchInsight(searchInsightNameInput)"
              height="40px" background-color="#F8F9FB" color="#0D0E17" outlined dense hide-details
              class="search-input-40" style="border-radius: 8px; font-size: 14px"
              @keyup.enter="searchInsight(searchInsightNameInput)"
            ></v-text-field>
            <div v-else @click="clickSearchedChip3()"
              class="d-flex align-center"
              style="height: 40px; width: 100%; background-color: #F0F2FF; border-radius: 8px; padding-left: 14px; padding-right: 14px; cursor: pointer"
            >
              <v-icon style="font-size: 24px; color: #687EFF; margin-right: 4px">
                mdi-magnify
              </v-icon>
              <div style="font-size: 14px; font-weight: 600; color: #687EFF">
                {{ searchInsightNameInput }}
              </div>
              <v-spacer></v-spacer>
              <div @click="clearSearchInput3()"
                class="default-theme-icon-btn d-flex align-center justify-center"
                style="width: 32px; height: 32px"
              >
                <v-icon style="font-size: 20px">mdi-close</v-icon>
              </div>
            </div>
          </div>
          <!-- loading -->
          <div v-if="isLoadingInsightList" class="d-flex align-center justify-center py-4" style="height: 100%">
            <v-progress-circular
              :size="40"
              color="#687EFF"
              indeterminate
            ></v-progress-circular>
          </div>
          <!-- 목록: 폴더 + 인사이트 -->
          <div v-else class="d-flex flex-column" style="gap: 8px; padding: 0px 10px 10px 10px">
            <!-- 폴더 -->
            <div v-for="folder_item in folderList" :key="'folder-' + folder_item.id"
              @click="clickFolderItem(folder_item)"
              class="hover-bg-color d-flex align-center"
              style="--hover-bg-color: #F8F9FB; height: 56px; padding: 0px 8px; gap: 10px; border-radius: 8px; cursor: pointer"
              :style="folder_item.id === $store.state.current_insight_folder?.id ? {backgroundColor: '#EFF0F6'} : {}"
            >
              <!-- 아이콘 박스 -->
              <div class="d-flex align-center justify-center"
                style="min-width: 38px; width: 38px; height: 38px; border-radius: 8px; background-color: #F8F9FB; border: 1px solid #E8EAF2"
              >
                <v-icon style="font-size: 20px; color: #162050">mdi-folder</v-icon>
              </div>
              <!-- 이름 / 부제 -->
              <div class="d-flex flex-column justify-center" style="gap: 2px; flex: 1; min-width: 0">
                <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                  {{ folder_item.name }}
                </div>
                <div style="font-size: 13px; font-weight: 400; line-height: 17px; color: #8A8DA8; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                  {{ folder_item.updated_at | dateFormatFilter }}
                  {{ folder_item.updated_at | timeFormatFilter }}
                  | {{ folder_item.dashboard_cnt ?? 0 }}개 대시보드
                </div>
              </div>
            </div>
            <!-- 인사이트 -->
            <div v-for="insight_item in insightList" :key="insight_item.id"
              @click="clickInsightItem(insight_item)"
              class="hover-bg-color d-flex align-center"
              style="--hover-bg-color: #F8F9FB; height: 56px; padding: 0px 8px; gap: 10px; border-radius: 8px; cursor: pointer"
              :style="insight_item.id === $store.state.current_insight?.id ? {backgroundColor: '#EFF0F6'} : {}"
            >
              <!-- 아이콘 박스 -->
              <div class="d-flex align-center justify-center"
                style="min-width: 38px; width: 38px; height: 38px; border-radius: 8px; background-color: #F8F9FB; border: 1px solid #E8EAF2"
              >
                <img :src="`/assets/menu_icon/insight_off.svg`" style="width: 20px; height: 20px">
              </div>
              <!-- 이름 / 부제 -->
              <div class="d-flex flex-column justify-center" style="gap: 2px; flex: 1; min-width: 0">
                <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                  {{ insight_item.name }}
                </div>
                <div style="font-size: 13px; font-weight: 400; line-height: 17px; color: #8A8DA8; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                  {{ (insightListOrder.includes('updated_at') ? insight_item.updated_at : insight_item.created_at) | dateFormatFilter }}
                  {{ (insightListOrder.includes('updated_at') ? insight_item.updated_at : insight_item.created_at) | timeFormatFilter }}
                  | {{ insight_item.chart_cnt || 0 }}개 차트
                </div>
              </div>
            </div>
          </div>
        </v-card>
      </v-menu>
    </div>
    <v-spacer></v-spacer>
    <!-- 도움말(채널톡) 버튼, 공지(노티) 버튼 (프로젝트 내부) -->
    <div v-if="mainRouter" class="d-flex align-center" style="gap: 4px; margin-left: 10px">
      <!-- 도움말(채널톡) 버튼 -->
      <div class="channel-talk-btn-1 hover-bg-color d-flex align-center justify-center" style="--hover-bg-color: #EFF0F6; width: 36px; height: 36px; border-radius: 8px; cursor: pointer">
        <img :src="`/assets/menu_icon/help_off.svg`" style="width: 20px; height: 20px">
      </div>
      <!-- 공지(노티) 버튼 -->
      <div
        class="hover-bg-color d-flex align-center justify-center" style="--hover-bg-color: #EFF0F6; width: 36px; height: 36px; border-radius: 8px; cursor: pointer"
      >
        <img :src="`/assets/menu_icon/notification_off.svg`" style="width: 20px; height: 20px">
      </div>
    </div>
    <!-- 대표 이미지(마이페이지) -->
    <div data-testid="navbar-profile-btn" class="d-flex align-center justify-center" style="margin-left: 10px; cursor: pointer" @click="showMypageDialog()">
      <v-avatar :color="$store.state.user_info.personal_color ? `#${$store.state.user_info.personal_color}` : '#2F54EB'" size="32">
        <img v-if="$store.state.user_info.picture && $store.state.user_info.picture.length > 0" :src="$store.state.user_info.picture" referrerpolicy="no-referrer">
        <div v-else-if="$store.state.user_info.email" style="font-size: 18px; font-weight: 400; line-height: 20px; color: #FFFFFF">
          {{ $store.state.user_info.email[0] }}
        </div>
      </v-avatar>
    </div>
  </div>
  
  <!-- drawer, main -->
  <div class="main-content d-flex"
    :style="$store.getters.isLoggedIn ? expireDateEndAlert ? {height: `calc(100vh - 48px - 44px)`} : {height: `calc(100vh - 48px)`} : {}"
  >
    <!-- drawer -->
    <div v-if="mainRouter"
      class="d-flex flex-column align-center"
      style="height: 100%; min-width: 70px; max-width: 70px; overflow: hidden; background-color: #F8F9FB; padding: 16px 5px 20px; gap: 16px"
    >
      <!-- 메뉴 -->
      <div v-for="(menu, menu_idx) in drawerItems.filter(v => v.parent_value !== 'group-custom').slice(0, drawerItemsCnt)" :key="menu_idx">
        <div @click="clickMenu(menu.routeName, menu.to)"
          class="menu-box d-flex flex-column align-center" style="width: 60px; height: 53px; cursor: pointer"
        >
          <!-- icon box -->
          <div class="menu-icon-box d-flex align-center justify-center" style="width: 36px; height: 36px; border-radius: 8px"
            :style="
              $route.name === menu.routeName || 
              ($route.name === 'Rpa' && menu.routeName === 'RpaList') || 
              ($route.name === 'RpaMain2' && menu.routeName === 'RpaList2') || 
              ($route.name === 'RpaMain3' && menu.routeName === 'RpaList2') || 
              ($route.name === 'Form' && menu.routeName === 'FormList') || 
              ($route.name === 'Insight2' && menu.routeName === 'InsightList') || 
              ($route.name === 'AsyncTaskLogDetail' && menu.routeName === 'AiAgent')
              ? {backgroundColor: '#E8EAF2'} : {}
            "
          >
            <img
              v-if="
                $route.name === menu.routeName || 
                ($route.name === 'Rpa' && menu.routeName === 'RpaList') || 
                ($route.name === 'RpaMain2' && menu.routeName === 'RpaList2') || 
                ($route.name === 'RpaMain3' && menu.routeName === 'RpaList2') || 
                ($route.name === 'Form' && menu.routeName === 'FormList') || 
                ($route.name === 'Insight2' && menu.routeName === 'InsightList') || 
                ($route.name === 'AsyncTaskLogDetail' && menu.routeName === 'AiAgent')
              "
              :src="getMenuIcon(menu.value, 'on')" style="width: 20px; height: 20px"
            ><!-- :src="`/assets/menu_icon/${menu.value}_on.svg`" style="width: 20px; height: 20px" -->
            <img v-else
              :src="getMenuIcon(menu.value, 'off')" style="width: 20px; height: 20px"
            ><!-- :src="`/assets/menu_icon/${menu.value}_off.svg`" style="width: 20px; height: 20px" -->
          </div>
          <!-- title -->
          <div style="font-size: 12px; font-weight: 500; line-height: 17px; letter-spacing: -0.02em; color: #162050">
            {{
              $i18n.locale === 'ko' ? menu.title : 
              $i18n.locale === 'en' ? menu.title_en : 
              menu.title
            }}
          </div>
        </div>
      </div>
      <!-- 더 보기 -->
      <div v-if="drawerItems.length > drawerItemsCnt">
        <v-menu offset-x right>
          <template v-slot:activator="{ on }">
            <div v-on="on" class="menu-box d-flex flex-column align-center" style="width: 60px; height: 53px; cursor: pointer">
              <!-- icon box -->
              <div class="menu-icon-box d-flex align-center justify-center" style="width: 36px; height: 36px; border-radius: 8px"
                :style="
                  drawerItems.slice(drawerItemsCnt).filter(v => $route.name === v.routeName).length > 0 || 
                  $route.name === 'Custom' || 
                  drawerItems.slice(drawerItemsCnt).filter(v => $route.name === 'Rpa' && v.routeName === 'RpaList').length > 0 || 
                  drawerItems.slice(drawerItemsCnt).filter(v => $route.name === 'RpaMain2' && v.routeName === 'RpaList2').length > 0 || 
                  drawerItems.slice(drawerItemsCnt).filter(v => $route.name === 'RpaMain3' && v.routeName === 'RpaList2').length > 0 || 
                  drawerItems.slice(drawerItemsCnt).filter(v => $route.name === 'Form' && v.routeName === 'FormList').length > 0 || 
                  drawerItems.slice(drawerItemsCnt).filter(v => $route.name === 'Insight2' && v.routeName === 'InsightList').length > 0 || 
                  drawerItems.slice(drawerItemsCnt).filter(v => $route.name === 'AsyncTaskLogDetail' && v.routeName === 'AiAgent').length > 0
                  ? {backgroundColor: '#E8EAF2'} : {}
                "
              >
                <v-icon style="font-size: 20px; color: #162050">
                  mdi-dots-horizontal
                </v-icon>
              </div>
              <!-- title -->
              <div style="font-size: 12px; font-weight: 500; line-height: 17px; letter-spacing: -0.02em; color: #162050">
                {{ $t('more') }}
              </div>
            </div>
          </template>
          <v-card>
            <div class="d-flex flex-column" style="width: 260px; padding: 8px; gap: 4px">
              <!-- 메뉴 -->
              <div v-for="(menu, menu_idx) in drawerItems.filter(v => v.parent_value !== 'group-custom').slice(drawerItemsCnt)" :key="menu_idx">
                <div @click="clickMenu(menu.routeName, menu.to)"
                  class="hover-bg-color d-flex align-start" style="--hover-bg-color: #F8F9FB; width: 100%; border-radius: 8px; padding: 8px; gap: 12px; cursor: pointer"
                  :style="
                    $route.name === menu.routeName || 
                    ($route.name === 'Rpa' && menu.routeName === 'RpaList') || 
                    ($route.name === 'RpaMain2' && menu.routeName === 'RpaList2') || 
                    ($route.name === 'RpaMain3' && menu.routeName === 'RpaList2') || 
                    ($route.name === 'Form' && menu.routeName === 'FormList') || 
                    ($route.name === 'Insight2' && menu.routeName === 'InsightList') || 
                    ($route.name === 'AsyncTaskLogDetail' && menu.routeName === 'AiAgent')
                    ? {backgroundColor: '#F8F9FB'} : {}
                  "
                >
                  <!-- icon box -->
                  <div class="d-flex align-center justify-center" style="width: 40px; height: 40px; border-radius: 8px; background-color: #EFF0F6">
                    <img :src="getMenuIcon(menu.value, 'on')" style="width: 20px; height: 20px">
                  </div>
                  <!-- title, sub -->
                  <div>
                    <!-- title -->
                    <div style="font-size: 14px; font-weight: 600; line-height: 20px; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 2px">
                      {{
                        $i18n.locale === 'ko' ? menu.title : 
                        $i18n.locale === 'en' ? menu.title_en : 
                        menu.title
                      }}
                    </div>
                    <!-- sub -->
                    <div style="font-size: 12px; font-weight: 400; line-height: 17px; letter-spacing: -0.02em; color: #414458">
                      {{
                        $i18n.locale === 'ko' ? menu.sub : 
                        $i18n.locale === 'en' ? menu.sub_en : 
                        menu.sub
                      }}
                    </div>
                  </div>
                </div>
              </div>
              <!-- 커스텀 -->
              <div v-if="drawerItems.filter(v => v.parent_value === 'group-custom').length > 0"
                @click="clickMenu('Custom', `/custom/${$store.state.current_project_pk}`)"
                class="hover-bg-color d-flex align-start" style="--hover-bg-color: #F8F9FB; width: 100%; border-radius: 8px; padding: 8px; gap: 12px; cursor: pointer"
                :style="$route.name === 'Custom' ? {backgroundColor: '#F8F9FB'} : {}"
              >
                <!-- icon box -->
                <div class="d-flex align-center justify-center" style="width: 40px; height: 40px; border-radius: 8px; background-color: #EFF0F6">
                  <img :src="`/assets/menu_icon/custom_on.svg`" style="width: 20px; height: 20px">
                </div>
                <!-- title, sub -->
                <div>
                  <!-- title -->
                  <div style="font-size: 14px; font-weight: 600; line-height: 20px; letter-spacing: -0.02em; color: #0D0E17; margin-bottom: 2px">
                    {{ $t('custom') }}
                  </div>
                  <!-- sub -->
                  <div style="font-size: 12px; font-weight: 400; line-height: 17px; letter-spacing: -0.02em; color: #414458">
                    {{ $t('custom_sub') }}
                  </div>
                </div>
              </div>
            </div>
          </v-card>
        </v-menu>
      </div>
      <v-spacer></v-spacer>
      <!-- 휴지통 -->
      <div @click="clickMenu('ProjectTrashCan', `/project-trash-can/${$store.state.current_project_pk}`)"
        class="menu-box d-flex flex-column align-center" style="width: 60px; height: 53px; cursor: pointer"
      >
        <!-- icon box -->
        <div class="menu-icon-box d-flex align-center justify-center" style="width: 36px; height: 36px; border-radius: 8px"
          :style="$route.name === 'ProjectTrashCan' ? {backgroundColor: '#E8EAF2'} : {}"
        >
          <img v-if="$route.name === 'ProjectTrashCan'"
            :src="`/assets/menu_icon/trashcan_on.svg`" style="width: 20px; height: 20px"
          >
          <img v-else
            :src="`/assets/menu_icon/trashcan_off.svg`" style="width: 20px; height: 20px"
          >
        </div>
        <!-- title -->
        <div style="font-size: 12px; font-weight: 500; line-height: 17px; letter-spacing: -0.03em; color: #162050">
          {{ $t('trash-can') }}
        </div>
      </div>
      <!-- 설정 -->
      <div @click="clickMenu('ProjectManagement', `/project-management/${$store.state.current_project_pk}`)"
        class="menu-box d-flex flex-column align-center" style="width: 60px; height: 53px; cursor: pointer"
      >
        <!-- icon box -->
        <div class="menu-icon-box d-flex align-center justify-center" style="width: 36px; height: 36px; border-radius: 8px"
          :style="$route.name === 'ProjectManagement' ? {backgroundColor: '#E8EAF2'} : {}"
        >
          <img v-if="$route.name === 'ProjectManagement'"
            :src="`/assets/menu_icon/setting_on.svg`" style="width: 20px; height: 20px"
          >
          <img v-else
            :src="`/assets/menu_icon/setting_off.svg`" style="width: 20px; height: 20px"
          >
        </div>
        <!-- title -->
        <div style="font-size: 12px; font-weight: 500; line-height: 17px; letter-spacing: -0.03em; color: #162050">
          {{ $t('settings') }}
        </div>
      </div>
    </div>
    <!-- main -->
    <v-main style="height: 100%"
      :style="
        (
          $route.name === 'LandingPage' || $route.name === 'LandingPage2' || 
          $route.name === 'Contact' || $route.name === 'ManualDownload' || 
          $route?.name?.includes('Product') || 
          $route?.name?.includes('Solution') || 
          $route.name === 'CustomerExample' || $route.name === 'CustomerExampleDetail' || 
          $route.name === 'PlanGuide' || $route.name === 'Voucher' ||
          $route.name === 'NewsRoom' || $route.name === 'NewsRoomDetail' || 
          $route.name === 'SignUp' || $route.name === 'SignUpCorporation' || $route.name === 'EmailConfirm' || $route.name === 'ResetPasswordConfirm' || 
          $route.name === 'PrivacyPolicy' || $route.name === 'Terms' || $route.name === 'NotFound'
        ) ? {overflow: 'hidden'} :
        mainRouter ? 
        {minWidth: 'calc(1536px - 70px)', maxWidth: 'calc(100% - 70px)'} : 
        {minWidth: '1536px'}
      "
    >
      <router-view ref="routerView"
        class="router-view"
        :top_alert="top_alert"
        :top_alert_height="top_alert_height"
        :searchPjtNameInput="searchPjtNameInput"
        :drawerItems="drawerItems"
        @setMypageDialog="setMypageDialog"
        @clickDemoBtn="clickDemoBtn"
        @clickContactBtn="clickContactBtn"
        @clickShowManualDownloadDialogBtn="clickShowManualDownloadDialogBtn"
      />
    </v-main>
  </div>

  <!-- footer -->
  <div class="footer" v-if="
      $route.name === 'LandingPage' || $route.name === 'LandingPage2' || 
      $route?.name?.includes('Product') || 
      $route?.name?.includes('Solution') || 
      $route.name === 'CustomerExample' || $route.name === 'CustomerExampleDetail' || 
      $route.name === 'NewsRoom' || $route.name === 'NewsRoomDetail' || 
      $route.name === 'PlanGuide' ||
      $route.name === 'Voucher'
    "
  >
    <!-- show-over-1441 -->
    <div class="show-over-1441" style="width: 100%">
      <div class="d-flex align-center justify-center" style="width: 100%; padding: 56px 0px 64px; background-color: #EFF0F6">
        <div class="d-flex flex-column justify-space-between" style="width: 1100px; height: 100%">
          <!-- 상단 -->
          <div class="d-flex align-start justify-start" style="gap: 72px">
            <!-- 리컬럼 로고 -->
            <div class="d-flex align-center" style="gap: 8px">
              <!-- logo -->
              <img src="/assets/recolumn-logo-black.svg" style="width: 15px; height: 23px">
              <!-- title -->
              <div style="font-size: 24px; font-weight: 600; line-height: 100%; letter-spacing: -0.02em; color: #0D0E17">
                Re:Column
              </div>
            </div>
            <!-- 메뉴 - 제품, 솔루션, 고객사례, (가격안내), 뉴스룸 -->
            <div class="d-flex flex-wrap align-start justify-start" style="gap: 40px 20px; width: 100%">
              <!-- 제품 -->
              <div style="min-width: 120px">
                <!-- title -->
                <div style="padding-left: 8px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #0D0E1799">
                  제품
                </div>
                <!-- 워크플로우 -->
                <div @click="goProductPage('/product-workflow')"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'ProductWorkflow' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    워크플로우
                  </div>
                </div>
                <!-- 엑셀 서식 -->
                <div @click="goProductPage('/product-excel-format')"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'ProductExcelFormat' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    엑셀 서식
                  </div>
                </div>
                <!-- 시각화 대시보드 -->
                <div @click="goProductPage('/product-visualization')"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'ProductVisualization' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    시각화 대시보드
                  </div>
                </div>
                <!-- 데이터 검증 -->
                <div @click="goProductPage('/product-data-verify')"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'ProductDataVerify' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    데이터 검증
                  </div>
                </div>
                <!-- 문서 폼 -->
                <div @click="goProductPage('/product-document-form')"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'ProductDocumentForm' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    문서 폼
                  </div>
                </div>
                <!-- 이메일 유효성 검증 -->
                <div @click="goProductPage('/product-email-verify')"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'ProductEmailVerify' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    이메일 유효성 검증
                  </div>
                </div>
                <!-- 협업 기능 -->
                <div @click="goProductPage('/product-cooperation')"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'ProductCooperation' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    협업 기능
                  </div>
                </div>
              </div>
              <!-- 솔루션 -->
              <div style="min-width: 120px">
                <!-- title -->
                <div style="padding-left: 8px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #0D0E1799">
                  솔루션
                </div>
                <!-- 이커머스 -->
                <div @click="goSolutionPage('/solution-ecommerce')"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'SolutionEcommerce' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    이커머스
                  </div>
                </div>
                <!-- 유통 ∙ 물류 -->
                <div @click="goSolutionPage('/solution-logistics')"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'SolutionLogistics' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    유통 ∙ 물류
                  </div>
                </div>
              </div>
              <!-- 고객사례 -->
              <div style="min-width: 120px">
                <!-- title -->
                <div style="padding-left: 8px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #0D0E1799">
                  고객사례
                </div>
                <!-- 고객사례 -->
                <div @click="goCustomerExample()"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'CustomerExample' || $route.name === 'CustomerExampleDetail' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    고객사례
                  </div>
                </div>
              </div>
              <!-- 가격안내 -->
              <div v-if="false" style="min-width: 120px">
                <!-- title -->
                <div style="padding-left: 8px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #0D0E1799">
                  가격안내
                </div>
                <!-- 플랜안내 -->
                <div @click="goPlanGuide()"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'PlanGuide' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    플랜안내
                  </div>
                </div>
                <!-- 바우처 -->
                <div @click="goVoucher()"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'Voucher' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    바우처
                  </div>
                </div>
              </div>
              <!-- 뉴스룸 -->
              <div style="min-width: 120px">
                <!-- title -->
                <div style="padding-left: 8px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #0D0E1799">
                  뉴스룸
                </div>
                <!-- 뉴스룸 -->
                <div @click="goNewsRoom()"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'NewsRoom' || $route.name === 'NewsRoomDetail' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    뉴스룸
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- divider -->
          <div style="width: 100%; height: 1px; margin: 40px 0px; background-color: #FFFFFF4D"></div>
          <!-- 하단 -->
          <div style="position: relative">
            <!-- (주)코그콤 -->
            <div style="font-weight: 600; font-size: 16px; line-height: 145%; color: #0D0E17; margin-bottom: 10px">
              (주)코그콤
            </div>
            <!-- 정보1 -->
            <div class="d-flex align-center" style="margin-bottom: 4px">
              <!-- 대표 정치훈 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                대표 정치훈
              </div>
              <!-- divider -->
              <div style="height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 4px"></div>
              <!-- 전화 02-2088-2096 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                전화 02-2088-2096
              </div>
              <!-- divider -->
              <div style="height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 4px"></div>
              <!-- 메일 contact@cogcom.kr -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                메일 contact@cogcom.kr
              </div>
              <!-- divider -->
              <div style="height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 4px"></div>
              <!-- 주소 서울특별시 송파구 송파대로 201 (송파 테라타워2), B동 1221호 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                주소 서울특별시 송파구 송파대로 201 (송파 테라타워2), B동 1221호
              </div>
            </div>
            <!-- 정보2 -->
            <div class="d-flex align-center">
              <!-- 사업자등록번호 378-86-01944 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                사업자등록번호 378-86-01944
              </div>
              <!-- divider -->
              <div style="height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 4px"></div>
              <!-- 통신판매업 제2024-서울광진-1178호 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                통신판매업 제2024-서울광진-1178호
              </div>
              <!-- divider -->
              <div style="height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 4px"></div>
              <!-- 이용약관 -->
              <div @click="goTermsOfUse()" style="font-size: 13px; font-weight: 600; line-height: 145%; color: #0D0E17CC; cursor: pointer">
                이용약관
              </div>
              <!-- divider -->
              <div style="height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 4px"></div>
              <!-- 개인정보처리방침 -->
              <div @click="goPrivacyPolicy()" style="font-size: 13px; font-weight: 600; line-height: 145%; color: #0D0E17CC; cursor: pointer">
                개인정보처리방침
              </div>
            </div>
            <!-- 우측 하단 버튼 (코그콤 링크드인, 코그콤 홈페이지) -->
            <div class="d-flex align-center" style="position: absolute; bottom: 6px; right: 0px; gap: 6px">
              <!-- 코그콤 링크드인 버튼 -->
              <div @click="goLinkedInPage()" class="hover-bg-color-0D0E170F d-flex align-center justify-center" style="width: 30px; height: 30px; border-radius: 4px; cursor: pointer">
                <img src="/assets/linked-in-logo-black.svg" style="width: 20px; height: 20px">
              </div>
              <!-- 코그콤 홈페이지 버튼 -->
              <div @click="goHomepage()" class="hover-bg-color-0D0E170F d-flex align-center justify-center" style="width: 30px; height: 30px; border-radius: 4px; cursor: pointer">
                <v-icon style="font-size: 24px; color: #0D0E1799">
                  mdi-web
                </v-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- show-over-1025-under-1440 -->
    <div class="show-over-1025-under-1440" style="width: 100%">
      <div class="d-flex align-center justify-center" style="width: 100%; padding: 56px 0px 64px; background-color: #EFF0F6">
        <div class="d-flex flex-column justify-space-between" style="width: calc(100% - calc(50px * 2)); height: 100%">
          <!-- 상단 -->
          <div class="d-flex align-start justify-start" style="gap: 72px">
            <!-- 리컬럼 로고 -->
            <div class="d-flex align-center" style="gap: 8px">
              <!-- logo -->
              <img src="/assets/recolumn-logo-black.svg" style="width: 15px; height: 23px">
              <!-- title -->
              <div style="font-size: 24px; font-weight: 600; line-height: 100%; letter-spacing: -0.02em; color: #0D0E17">
                Re:Column
              </div>
            </div>
            <!-- 메뉴 - 제품, 솔루션, 고객사례, (가격안내), 뉴스룸 -->
            <div class="d-flex flex-wrap align-start justify-start" style="gap: 40px 20px; width: 100%">
              <!-- 제품 -->
              <div style="min-width: 120px">
                <!-- title -->
                <div style="padding-left: 8px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #0D0E1799">
                  제품
                </div>
                <!-- 워크플로우 -->
                <div @click="goProductPage('/product-workflow')"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'ProductWorkflow' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    워크플로우
                  </div>
                </div>
                <!-- 엑셀 서식 -->
                <div @click="goProductPage('/product-excel-format')"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'ProductExcelFormat' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    엑셀 서식
                  </div>
                </div>
                <!-- 시각화 대시보드 -->
                <div @click="goProductPage('/product-visualization')"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'ProductVisualization' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    시각화 대시보드
                  </div>
                </div>
                <!-- 데이터 검증 -->
                <div @click="goProductPage('/product-data-verify')"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'ProductDataVerify' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    데이터 검증
                  </div>
                </div>
                <!-- 문서 폼 -->
                <div @click="goProductPage('/product-document-form')"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'ProductDocumentForm' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    문서 폼
                  </div>
                </div>
                <!-- 이메일 유효성 검증 -->
                <div @click="goProductPage('/product-email-verify')"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'ProductEmailVerify' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    이메일 유효성 검증
                  </div>
                </div>
                <!-- 협업 기능 -->
                <div @click="goProductPage('/product-cooperation')"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'ProductCooperation' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    협업 기능
                  </div>
                </div>
              </div>
              <!-- 솔루션 -->
              <div style="min-width: 120px">
                <!-- title -->
                <div style="padding-left: 8px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #0D0E1799">
                  솔루션
                </div>
                <!-- 이커머스 -->
                <div @click="goSolutionPage('/solution-ecommerce')"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'SolutionEcommerce' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    이커머스
                  </div>
                </div>
                <!-- 유통 ∙ 물류 -->
                <div @click="goSolutionPage('/solution-logistics')"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'SolutionLogistics' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    유통 ∙ 물류
                  </div>
                </div>
              </div>
              <!-- 고객사례 -->
              <div style="min-width: 120px">
                <!-- title -->
                <div style="padding-left: 8px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #0D0E1799">
                  고객사례
                </div>
                <!-- 고객사례 -->
                <div @click="goCustomerExample()"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'CustomerExample' || $route.name === 'CustomerExampleDetail' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    고객사례
                  </div>
                </div>
              </div>
              <!-- 가격안내 -->
              <div v-if="false" style="min-width: 120px">
                <!-- title -->
                <div style="padding-left: 8px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #0D0E1799">
                  가격안내
                </div>
                <!-- 플랜안내 -->
                <div @click="goPlanGuide()"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'PlanGuide' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    플랜안내
                  </div>
                </div>
                <!-- 바우처 -->
                <div @click="goVoucher()"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'Voucher' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    바우처
                  </div>
                </div>
              </div>
              <!-- 뉴스룸 -->
              <div style="min-width: 120px">
                <!-- title -->
                <div style="padding-left: 8px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #0D0E1799">
                  뉴스룸
                </div>
                <!-- 뉴스룸 -->
                <div @click="goNewsRoom()"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'NewsRoom' || $route.name === 'NewsRoomDetail' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    뉴스룸
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- divider -->
          <div style="width: 100%; height: 1px; margin: 40px 0px; background-color: #FFFFFF4D"></div>
          <!-- 하단 -->
          <div style="position: relative">
            <!-- (주)코그콤 -->
            <div style="font-weight: 600; font-size: 16px; line-height: 145%; color: #0D0E17; margin-bottom: 10px">
              (주)코그콤
            </div>
            <!-- 정보1 -->
            <div class="d-flex align-center" style="margin-bottom: 4px">
              <!-- 대표 정치훈 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                대표 정치훈
              </div>
              <!-- divider -->
              <div style="height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 4px"></div>
              <!-- 전화 02-2088-2096 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                전화 02-2088-2096
              </div>
              <!-- divider -->
              <div style="height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 4px"></div>
              <!-- 메일 contact@cogcom.kr -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                메일 contact@cogcom.kr
              </div>
              <!-- divider -->
              <div style="height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 4px"></div>
              <!-- 주소 서울특별시 송파구 송파대로 201 (송파 테라타워2), B동 1221호 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                주소 서울특별시 송파구 송파대로 201 (송파 테라타워2), B동 1221호
              </div>
            </div>
            <!-- 정보2 -->
            <div class="d-flex align-center">
              <!-- 사업자등록번호 378-86-01944 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                사업자등록번호 378-86-01944
              </div>
              <!-- divider -->
              <div style="height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 4px"></div>
              <!-- 통신판매업 제2024-서울광진-1178호 -->
              <div style="font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                통신판매업 제2024-서울광진-1178호
              </div>
              <!-- divider -->
              <div style="height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 4px"></div>
              <!-- 이용약관 -->
              <div @click="goTermsOfUse()" style="font-size: 13px; font-weight: 600; line-height: 145%; color: #0D0E17CC; cursor: pointer">
                이용약관
              </div>
              <!-- divider -->
              <div style="height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 4px"></div>
              <!-- 개인정보처리방침 -->
              <div @click="goPrivacyPolicy()" style="font-size: 13px; font-weight: 600; line-height: 145%; color: #0D0E17CC; cursor: pointer">
                개인정보처리방침
              </div>
            </div>
            <!-- 우측 하단 버튼 (코그콤 링크드인, 코그콤 홈페이지) -->
            <div class="d-flex align-center" style="position: absolute; bottom: 6px; right: 0px; gap: 6px">
              <!-- 코그콤 링크드인 버튼 -->
              <div @click="goLinkedInPage()" class="hover-bg-color-0D0E170F d-flex align-center justify-center" style="width: 30px; height: 30px; border-radius: 4px; cursor: pointer">
                <img src="/assets/linked-in-logo-black.svg" style="width: 20px; height: 20px">
              </div>
              <!-- 코그콤 홈페이지 버튼 -->
              <div @click="goHomepage()" class="hover-bg-color-0D0E170F d-flex align-center justify-center" style="width: 30px; height: 30px; border-radius: 4px; cursor: pointer">
                <v-icon style="font-size: 24px; color: #0D0E1799">
                  mdi-web
                </v-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- show-over-320-under-1024 -->
    <div class="show-over-320-under-1024" style="width: 100%">
      <div class="d-flex align-center justify-center" style="width: 100%; padding: 56px 0px 64px; background-color: #EFF0F6">
        <div class="d-flex flex-column justify-space-between" style="width: calc(100% - calc(24px * 2))">
          <!-- 상단 -->
          <div class="d-flex flex-column align-start justify-start" style="gap: 56px">
            <!-- 리컬럼 로고 -->
            <div class="d-flex align-center" style="gap: 8px">
              <!-- logo -->
              <img src="/assets/recolumn-logo-black.svg" style="width: 15px; height: 23px">
              <!-- title -->
              <div style="font-size: 24px; font-weight: 600; line-height: 100%; letter-spacing: -0.02em; color: #0D0E17">
                Re:Column
              </div>
            </div>
            <!-- 메뉴 - 제품, 솔루션, 고객사례, (가격안내), 뉴스룸 -->
            <div class="d-flex flex-wrap align-start justify-start" style="gap: 40px 20px; width: 100%">
              <!-- 제품 -->
              <div style="min-width: 120px">
                <!-- title -->
                <div style="padding-left: 8px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #0D0E1799">
                  제품
                </div>
                <!-- 워크플로우 -->
                <div @click="goProductPage('/product-workflow')"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'ProductWorkflow' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    워크플로우
                  </div>
                </div>
                <!-- 엑셀 서식 -->
                <div @click="goProductPage('/product-excel-format')"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'ProductExcelFormat' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    엑셀 서식
                  </div>
                </div>
                <!-- 시각화 대시보드 -->
                <div @click="goProductPage('/product-visualization')"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'ProductVisualization' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    시각화 대시보드
                  </div>
                </div>
                <!-- 데이터 검증 -->
                <div @click="goProductPage('/product-data-verify')"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'ProductDataVerify' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    데이터 검증
                  </div>
                </div>
                <!-- 문서 폼 -->
                <div @click="goProductPage('/product-document-form')"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'ProductDocumentForm' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    문서 폼
                  </div>
                </div>
                <!-- 이메일 유효성 검증 -->
                <div @click="goProductPage('/product-email-verify')"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'ProductEmailVerify' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    이메일 유효성 검증
                  </div>
                </div>
                <!-- 협업 기능 -->
                <div @click="goProductPage('/product-cooperation')"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'ProductCooperation' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    협업 기능
                  </div>
                </div>
              </div>
              <!-- 솔루션 -->
              <div style="min-width: 120px">
                <!-- title -->
                <div style="padding-left: 8px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #0D0E1799">
                  솔루션
                </div>
                <!-- 이커머스 -->
                <div @click="goSolutionPage('/solution-ecommerce')"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'SolutionEcommerce' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    이커머스
                  </div>
                </div>
                <!-- 유통 ∙ 물류 -->
                <div @click="goSolutionPage('/solution-logistics')"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'SolutionLogistics' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    유통 ∙ 물류
                  </div>
                </div>
              </div>
              <!-- 고객사례 -->
              <div style="min-width: 120px">
                <!-- title -->
                <div style="padding-left: 8px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #0D0E1799">
                  고객사례
                </div>
                <!-- 고객사례 -->
                <div @click="goCustomerExample()"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'CustomerExample' || $route.name === 'CustomerExampleDetail' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    고객사례
                  </div>
                </div>
              </div>
              <!-- 가격안내 -->
              <div v-if="false" style="min-width: 120px">
                <!-- title -->
                <div style="padding-left: 8px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #0D0E1799">
                  가격안내
                </div>
                <!-- 플랜안내 -->
                <div @click="goPlanGuide()"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'PlanGuide' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    플랜안내
                  </div>
                </div>
                <!-- 바우처 -->
                <div @click="goVoucher()"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'Voucher' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    바우처
                  </div>
                </div>
              </div>
              <!-- 뉴스룸 -->
              <div style="min-width: 120px">
                <!-- title -->
                <div style="padding-left: 8px; margin-bottom: 12px; font-size: 14px; font-weight: 500; line-height: 145%; letter-spacing: -0.02em; color: #0D0E1799">
                  뉴스룸
                </div>
                <!-- 뉴스룸 -->
                <div @click="goNewsRoom()"
                  class="hover-bg-color-0D0E170F d-flex align-center" style="height: 26px; width: fit-content; border-radius: 4px; padding: 0px 8px; margin-bottom: 2px; cursor: pointer"
                >
                  <div style="font-weight: 400; font-size: 15px; line-height: 145%; letter-spacing: -0.02em"
                    :style="$route.name === 'NewsRoom' || $route.name === 'NewsRoomDetail' ? {color: '#0D0E17'} : {color: '#0D0E17'}"
                  >
                    뉴스룸
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- divider -->
          <div style="width: 100%; height: 1px; margin: 40px 0px; background-color: #FFFFFF4D"></div>
          <!-- 하단 -->
          <div>
            <!-- (주)코그콤 -->
            <div style="font-weight: 600; font-size: 16px; line-height: 145%; color: #0D0E17; margin-bottom: 10px">
              (주)코그콤
            </div>
            <!-- 정보 -->
            <div style="margin-bottom: 16px">
              <!-- 대표 정치훈 -->
              <span style="word-break: keep-all; font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                대표 정치훈
              </span>
              <!-- divider -->
              <div style="display: inline-block; height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 1px -2px 0px"></div>
              <!-- 전화 02-2088-2096 -->
              <span style="word-break: keep-all; font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                전화 02-2088-2096
              </span>
              <!-- divider -->
              <div style="display: inline-block; height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 1px -2px 0px"></div>
              <!-- 메일 contact@cogcom.kr -->
              <span style="word-break: keep-all; font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                메일 contact@cogcom.kr
              </span>
              <!-- divider -->
              <div style="display: inline-block; height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 1px -2px 0px"></div>
              <!-- 주소 서울특별시 송파구 송파대로 201 (송파 테라타워2), B동 1221호 -->
              <span style="word-break: keep-all; font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                주소 서울특별시 송파구 송파대로 201 (송파 테라타워2), B동 1221호
              </span>
              <!-- divider -->
              <div style="display: inline-block; height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 1px -2px 0px"></div>
              <!-- 사업자등록번호 378-86-01944 -->
              <span style="word-break: keep-all; font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                사업자등록번호 378-86-01944
              </span>
              <!-- divider -->
              <div style="display: inline-block; height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 1px -2px 0px"></div>
              <!-- 통신판매업 제2024-서울광진-1178호 -->
              <span style="word-break: keep-all; font-size: 13px; font-weight: 400; line-height: 145%; color: #0D0E1799">
                통신판매업 제2024-서울광진-1178호
              </span>
              <!-- divider -->
              <div style="display: inline-block; height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 1px -2px 0px"></div>
              <!-- 이용약관 -->
              <span @click="goTermsOfUse()" style="word-break: keep-all; font-size: 13px; font-weight: 600; line-height: 145%; color: #0D0E17CC; cursor: pointer">
                이용약관
              </span>
              <!-- divider -->
              <div style="display: inline-block; height: 12px; width: 1px; background-color: #FFFFFF1A; margin: 0px 1px -2px 0px"></div>
              <!-- 개인정보처리방침 -->
              <span @click="goPrivacyPolicy()" style="word-break: keep-all; font-size: 13px; font-weight: 600; line-height: 145%; color: #0D0E17CC; cursor: pointer">
                개인정보처리방침
              </span>
            </div>
            <!-- 하단 버튼 (코그콤 링크드인, 코그콤 홈페이지) -->
            <div class="d-flex align-center" style="gap: 6px">
              <!-- 코그콤 링크드인 버튼 -->
              <div @click="goLinkedInPage()" class="hover-bg-color-0D0E170F d-flex align-center justify-center" style="width: 30px; height: 30px; border-radius: 4px; cursor: pointer">
                <img src="/assets/linked-in-logo-black.svg" style="width: 20px; height: 20px">
              </div>
              <!-- 코그콤 홈페이지 버튼 -->
              <div @click="goHomepage()" class="hover-bg-color-0D0E170F d-flex align-center justify-center" style="width: 30px; height: 30px; border-radius: 4px; cursor: pointer">
                <v-icon style="font-size: 24px; color: #0D0E1799">
                  mdi-web
                </v-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- 기한 만료 알림 dialog (n일 이내) -->
  <v-dialog v-model="expireDateEndDialog" max-width="440px">
    <v-card style="border-radius: 16px; position: relative">
      <!-- 취소 버튼 -->
      <div @click="expireDateEndDialog = false"
        class="default-icon-btn d-flex align-center justify-center"
        style="position: absolute; top: 14px; right: 14px; width: 32px; height: 32px"
      >
        <v-icon style="font-size: 24px; color: #8A8DA8">
          mdi-close
        </v-icon>
      </div>
      <div class="d-flex flex-column align-center" style="padding: 40px">
        <!-- 리컬럼 로고 -->
        <div class="d-flex align-center" style="margin-bottom: 24px">
          <!-- logo -->
          <img src="/assets/recolumn-logo.svg" style="width: 15px; height: 23px; object-fit: contain; margin-right: 8px">
          <!-- title -->
          <div style="font-size: 24px; font-weight: 600; line-height: 100%; color: #0D0E17; letter-spacing: -0.02em">
            Re:Column
          </div>
        </div>
        <!-- text -->
        <div style="text-align: center; font-size: 27px; font-weight: 700; line-height: 38px; color: #414458; margin-bottom: 24px">
          무료체험이 종료되었습니다.
        </div>
        <!-- sub -->
        <div style="text-align: center; font-size: 14px; font-weight: 400; line-height: 20px; color: #8A8DA8; margin-bottom: 32px">
          종료 일자로부터 7일간 읽기 전용 모드가 제공됩니다.
          <br>
          지금 정식 도입하면 리컬럼의 모든 기능을 사용하실 수 있습니다.
        </div>
        <!-- 도입 문의하기 버튼 -->
        <div @click="expireDateEndDialog = false; contactDialog = true"
          class="default-gradient-theme-btn d-flex align-center justify-center"
          style="height: 56px; width: 100%"
        >
          <div style="font-size: 18px; font-weight: 700; line-height: 22px; color: #ffffff">
            도입 문의하기
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
  <!-- 기한 만료 알림 dialog (n일 이후) -->
  <v-dialog v-model="$store.state.expireDateEndDialog" max-width="440px">
    <v-card style="border-radius: 16px; position: relative">
      <!-- 취소 버튼 -->
      <div @click="$store.state.expireDateEndDialog = false"
        class="default-icon-btn d-flex align-center justify-center"
        style="position: absolute; top: 14px; right: 14px; width: 32px; height: 32px"
      >
        <v-icon style="font-size: 24px; color: #8A8DA8">
          mdi-close
        </v-icon>
      </div>
      <div class="d-flex flex-column align-center" style="padding: 40px">
        <!-- 리컬럼 로고 -->
        <div class="d-flex align-center" style="margin-bottom: 24px">
          <!-- logo -->
          <img src="/assets/recolumn-logo.svg" style="width: 15px; height: 23px; object-fit: contain; margin-right: 8px">
          <!-- title -->
          <div style="font-size: 24px; font-weight: 600; line-height: 100%; color: #0D0E17; letter-spacing: -0.02em">
            Re:Column
          </div>
        </div>
        <!-- text -->
        <div style="text-align: center; font-size: 27px; font-weight: 700; line-height: 38px; color: #414458; margin-bottom: 24px">
          무료체험이 종료되었습니다.
        </div>
        <!-- sub -->
        <div style="text-align: center; font-size: 14px; font-weight: 400; line-height: 20px; color: #8A8DA8; margin-bottom: 32px">
          무료체험 및 읽기 전용 모드 제공 기간이 종료되었습니다.
          <br>
          지금 정식 도입하면 계정을 복구하고 계속 사용하실 수 있습니다.
        </div>
        <!-- 도입 문의하기 버튼 -->
        <div @click="$store.state.expireDateEndDialog = false; contactDialog = true"
          class="default-gradient-theme-btn d-flex align-center justify-center"
          style="height: 56px; width: 100%"
        >
          <div style="font-size: 18px; font-weight: 700; line-height: 22px; color: #ffffff">
            도입 문의하기
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>

  <!-- 문의하기 dialog (web) -->
  <!-- v-if="window_innerWidth > 440" -->
  <v-dialog v-model="contactDialog" max-width="420px">
    <v-card style="border-radius: 16px; padding: 24px 30px; position: relative">
      <!-- 취소 버튼 -->
      <div @click="contactDialog = false"
        class="default-icon-btn d-flex align-center justify-center"
        style="position: absolute; top: 8px; right: 8px; width: 40px; height: 40px"
      >
        <v-icon style="font-size: 20px; color: #8A8DA8">
          mdi-close
        </v-icon>
      </div>
      <!-- title -->
      <div style="font-weight: 700; font-size: 18px; line-height: 24px; color: #0D0E17; margin-bottom: 4px">
        문의하기
      </div>
      <!-- sub -->
      <div style="font-weight: 400; font-size: 14px; line-height: 20px; color: #414458; margin-bottom: 24px">
        궁금한 점을 편하게 물어보실 수 있도록 연락드립니다.
      </div>
      <!-- 문의 내용 title -->
      <div style="padding-left: 2px; font-weight: 400; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 8px">
        문의 내용
      </div>
      <!-- 문의 내용 입력창 -->
      <div style="height: 90px; width: 100%; border-radius: 8px; border: 1px solid #E8EAF2; background-color: #ffffff; padding: 12px 16px; margin-bottom: 16px">
        <textarea v-model="contactDialog_inquiryInput" ref="contactDialog_inquiryInput" type="text" placeholder="우리 회사의 보고서 제작 프로세스를 세팅하려면 대략 며칠이 걸리는지 궁금합니다."
          class="input-area focus-hide-placeholder-input" style="width: 100%; height: 100%; font-size: 14px; font-weight: 400; line-height: 140%; color: #414458"
        ></textarea>
      </div>
      <!-- 원하시는 답변 경로 * title -->
      <div style="padding-left: 2px; font-weight: 400; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 8px">
        원하시는 답변 경로 <span style="color: #687EFF">*</span>
      </div>
      <!-- 원하시는 답변 경로 선택창 -->
      <div style="overflow: hidden auto; border-radius: 8px; border: 1px solid #E8EAF2; background-color: #ffffff; padding: 4px; margin-bottom: 16px">
        <div v-for="item in contactDialog_answerPath_optionList" :key="item.value">
          <div class="hover-bg-color d-flex flex-column" style="--hover-bg-color: #F8F9FB; width: 100%; border-radius: 8px; cursor: pointer; overflow: hidden"
            :style="contactDialog_answerPath === item.value ? {backgroundColor: '#F0F2FF'} : {}"
            @click="contactDialog_answerPath = item.value"
          >
            <!-- radio btn, text -->
            <div class="d-flex align-center" style="width: 100%; height: 40px">
              <!-- radio btn -->
              <div class="checkbox-btn d-flex align-center justify-center" style="width: 40px; height: 40px">
                <v-icon v-if="contactDialog_answerPath === item.value" style="font-size: 20px; color: #687EFF">
                  mdi-radiobox-marked
                </v-icon>
                <v-icon v-else style="font-size: 20px; color: #D8DAE9">
                  mdi-radiobox-blank
                </v-icon>
              </div>
              <!-- text -->
              <div style="font-size: 14px; line-height: 18px"
                :style="contactDialog_answerPath === item.value ? {fontWeight: 600, color: '#687EFF'} : {fontWeight: 500, color: '#414458'}"
              >
                {{ item.text }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 통화 가능한 시간 * title - 원하시는 답변 경로 === 전화 (contactDialog_answerPath === '전화') -->
      <div v-if="contactDialog_answerPath === '전화'" style="padding-left: 2px; font-weight: 400; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 8px">
        통화 가능한 시간 <span style="color: #687EFF">*</span>
      </div>
      <!-- 통화 가능한 시간 입력창 - 원하시는 답변 경로 === 전화 (contactDialog_answerPath === '전화') -->
      <div v-if="contactDialog_answerPath === '전화'" class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #ffffff; margin-bottom: 16px">
        <input v-model="contactDialog_ableTimeInput" ref="contactDialog_ableTimeInput" type="text" placeholder="내일 오전 11시~오후 1시 사이에 가능합니다."
          class="input-area focus-hide-placeholder-input" style="width: 100%; height: 100%; font-size: 14px; font-weight: 400; line-height: 18px; color: #414458"
        >
      </div>
      <!-- 연락처 title -->
      <div style="padding-left: 2px; font-weight: 400; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 8px">
        연락처 <span style="color: #687EFF">*</span>
      </div>
      <!-- 연락처 입력창 -->
      <div class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #ffffff; margin-bottom: 4px">
        <input v-model="contactDialog_contactInput" ref="contactDialog_contactInput" type="text"
          :placeholder="contactDialog_answerPath === '전화' ? '010-1234-5678' : 'contact@cogcom.kr'"
          class="input-area focus-hide-placeholder-input" style="width: 100%; height: 100%; font-size: 14px; font-weight: 400; line-height: 18px; color: #414458"
        >
      </div>
      <!-- 개인정보처리방침에 동의합니다. -->
      <div class="d-flex align-center" style="width: 100%; margin-bottom: 12px; transform: translateX(-8px)">
        <div class="checkbox-btn d-flex align-center justify-center" style="width: 36px; height: 36px" @click="contactDialog_privacyPolicy = !contactDialog_privacyPolicy">
          <v-icon v-if="contactDialog_privacyPolicy" style="font-size: 18px; color: #687EFF">
            mdi-checkbox-marked
          </v-icon>
          <v-icon v-else style="font-size: 18px; color: #D8DAE9">
            mdi-checkbox-blank-outline
          </v-icon>
        </div>
        <div style="font-size: 14px; font-weight: 400; line-height: 18px; color: #414458">
          <span style="cursor: pointer; text-decoration: underline" @click="openPrivacyPolicy()">개인정보처리방침</span>에 동의합니다.
        </div>
      </div>
      <!-- 문의하기 버튼 -->
      <div @click="clickContactBtnInDialog()"
        class="default-gradient-theme-btn d-flex align-center justify-center"
        style="height: 56px; width: 100%"
        :style="
          contactDialog_answerPath && 
          (contactDialog_answerPath !== '전화' || (contactDialog_answerPath === '전화' && contactDialog_ableTimeInput)) && 
          contactDialog_contactInput && 
          contactDialog_privacyPolicy
          ? {} 
          : {pointerEvents: 'none', cursor: 'none', opacity: '0.4'}
        "
      >
        <div style="font-size: 18px; font-weight: 700; line-height: 22px; color: #ffffff">
          문의하기
        </div>
      </div>
    </v-card>
  </v-dialog>
  <!-- 문의하기 완료 dialog -->
  <v-dialog v-model="contactDialog_success" max-width="440px">
    <v-card style="border-radius: 16px; position: relative">
      <!-- 취소 버튼 -->
      <div @click="contactDialog_success = false"
        class="default-icon-btn d-flex align-center justify-center"
        style="position: absolute; top: 14px; right: 14px; width: 32px; height: 32px"
      >
        <v-icon style="font-size: 24px; color: #8A8DA8">
          mdi-close
        </v-icon>
      </div>
      <div class="d-flex flex-column align-center" style="padding: 40px 0px">
        <!-- 리컬럼 로고 -->
        <div class="d-flex align-center" style="margin-bottom: 24px">
          <!-- logo -->
          <img src="/assets/recolumn-logo-D8DAE9.svg" style="width: 15px; height: 23px; object-fit: contain; margin-right: 8px">
          <!-- title -->
          <div style="font-size: 24px; font-weight: 600; line-height: 100%; color: #D8DAE9; letter-spacing: -0.02em">
            Re:Column
          </div>
        </div>
        <!-- text -->
        <div style="text-align: center; font-size: 27px; font-weight: 700; line-height: 38px; color: #414458; margin-bottom: 24px">
          정상적으로 접수되었습니다!
        </div>
        <!-- sub -->
        <div style="text-align: center; font-size: 14px; font-weight: 400; line-height: 20px; color: #8A8DA8; margin-bottom: 6px">
          도입 문의가 정상적으로 접수되었습니다. <br>
          잠시 기다려주시면 1 영업일 이내에 <br>
          입력하신 연락처로 담당자가 연락 드리겠습니다. <br><br>
          감사합니다.
        </div>
      </div>
    </v-card>
  </v-dialog>
  <!-- 문의하기 (mobile) -->
  <div v-if="false && contactDialog && window_innerWidth <= 440" style="position: relative; width: 100vw; background-color: #ffffff"
    :style="top_alert ? {marginTop: `calc(${top_alert_height} + 60px)`} : {marginTop: '60px'}"
  >
    <!-- 상단 영역 (title, sub, 취소 버튼) -->
    <div style="position: fixed; z-index: 1; width: 100%; padding: 20px 24px 28px; background-color: #ffffff" :style="top_alert ? {top: `calc(${top_alert_height} + 60px)`} : {top: '60px'}">
      <!-- 취소 버튼 -->
      <div @click="contactDialog = false"
        class="default-icon-btn d-flex align-center justify-center"
        style="position: absolute; top: 8px; right: 8px; width: 40px; height: 40px"
      >
        <v-icon style="font-size: 20px; color: #8A8DA8">
          mdi-close
        </v-icon>
      </div>
      <!-- title -->
      <div style="font-weight: 700; font-size: 22px; line-height: 140%; color: #0D0E17; margin-bottom: 4px">
        문의하기
      </div>
      <!-- sub -->
      <div style="font-weight: 400; font-size: 14px; line-height: 20px; letter-spacing: -0.02em; color: #414458">
        궁금한 점을 편하게 물어보실 수 있도록 연락드립니다.
      </div>
    </div>
    <!-- content -->
    <div style="padding: 107px 24px 104px">
      <!-- 문의 내용 title -->
      <div style="padding-left: 2px; font-weight: 400; font-size: 15px; line-height: 140%; color: #414458; margin-bottom: 8px">
        문의 내용
      </div>
      <!-- 문의 내용 입력창 -->
      <div style="height: 116px; width: 100%; border-radius: 8px; border: 1px solid #E8EAF2; background-color: #ffffff; padding: 10px 14px; margin-bottom: 24px">
        <textarea v-model="contactDialog_inquiryInput" ref="contactDialog_inquiryInput" type="text" placeholder="우리 회사의 보고서 제작 프로세스를 세팅하려면 대략 며칠이 걸리는지 궁금합니다."
          class="input-area-3 focus-hide-placeholder-input" style="width: 100%; height: 100%; font-size: 17px; font-weight: 400; line-height: 140%; color: #414458"
        ></textarea>
      </div>
      <!-- 원하시는 답변 경로 * title -->
      <div style="padding-left: 2px; font-weight: 400; font-size: 15px; line-height: 140%; color: #414458; margin-bottom: 8px">
        원하시는 답변 경로 <span style="color: #687EFF">*</span>
      </div>
      <!-- 원하시는 답변 경로 선택창 -->
      <div style="overflow: hidden auto; border-radius: 8px; border: 1px solid #E8EAF2; background-color: #ffffff; padding: 8px; margin-bottom: 24px">
        <div v-for="item in contactDialog_answerPath_optionList" :key="item.value">
          <div class="hover-bg-color d-flex flex-column" style="--hover-bg-color: #F8F9FB; width: 100%; border-radius: 8px; cursor: pointer; overflow: hidden"
            :style="contactDialog_answerPath === item.value ? {backgroundColor: '#F0F2FF'} : {}"
            @click="contactDialog_answerPath = item.value"
          >
            <!-- radio btn, text -->
            <div class="d-flex align-center" style="width: 100%; height: 48px">
              <!-- radio btn -->
              <div class="checkbox-btn d-flex align-center justify-center" style="width: 40px; height: 40px">
                <v-icon v-if="contactDialog_answerPath === item.value" style="font-size: 20px; color: #687EFF">
                  mdi-radiobox-marked
                </v-icon>
                <v-icon v-else style="font-size: 20px; color: #D8DAE9">
                  mdi-radiobox-blank
                </v-icon>
              </div>
              <!-- text -->
              <div style="font-size: 17px; line-height: 140%"
                :style="contactDialog_answerPath === item.value ? {fontWeight: 600, color: '#687EFF'} : {fontWeight: 500, color: '#414458'}"
              >
                {{ item.text }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 통화 가능한 시간 * title - 원하시는 답변 경로 === 전화 (contactDialog_answerPath === '전화') -->
      <div v-if="contactDialog_answerPath === '전화'" style="padding-left: 2px; font-weight: 400; font-size: 15px; line-height: 140%; color: #414458; margin-bottom: 8px">
        통화 가능한 시간 <span style="color: #687EFF">*</span>
      </div>
      <!-- 통화 가능한 시간 입력창 - 원하시는 답변 경로 === 전화 (contactDialog_answerPath === '전화') -->
      <div v-if="contactDialog_answerPath === '전화'" class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #ffffff; margin-bottom: 24px">
        <input v-model="contactDialog_ableTimeInput" ref="contactDialog_ableTimeInput" type="text" placeholder="내일 오전 11시~오후 1시 사이에 가능합니다."
          class="input-area-3 focus-hide-placeholder-input" style="width: 100%; height: 100%; font-size: 17px; font-weight: 400; line-height: 140%; color: #414458"
        >
      </div>
      <!-- 연락처 title -->
      <div style="padding-left: 2px; font-weight: 400; font-size: 15px; line-height: 140%; color: #414458; margin-bottom: 8px">
        연락처 <span style="color: #687EFF">*</span>
      </div>
      <!-- 연락처 입력창 -->
      <div class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #ffffff; margin-bottom: 10px">
        <input v-model="contactDialog_contactInput" ref="contactDialog_contactInput" type="text"
          :placeholder="contactDialog_answerPath === '전화' ? '010-1234-5678' : 'contact@cogcom.kr'"
          class="input-area-3 focus-hide-placeholder-input" style="width: 100%; height: 100%; font-size: 17px; font-weight: 400; line-height: 140%; color: #414458"
        >
      </div>
      <!-- 개인정보처리방침에 동의합니다. -->
      <div class="d-flex align-center" style="width: 100%; margin-bottom: 0px; transform: translateX(-8px)">
        <div class="checkbox-btn d-flex align-center justify-center" style="width: 36px; height: 36px" @click="contactDialog_privacyPolicy = !contactDialog_privacyPolicy">
          <v-icon v-if="contactDialog_privacyPolicy" style="font-size: 18px; color: #687EFF">
            mdi-checkbox-marked
          </v-icon>
          <v-icon v-else style="font-size: 18px; color: #D8DAE9">
            mdi-checkbox-blank-outline
          </v-icon>
        </div>
        <div style="font-size: 14px; font-weight: 400; line-height: 18px; color: #414458">
          <span style="cursor: pointer; text-decoration: underline" @click="openPrivacyPolicy()">개인정보처리방침</span>에 동의합니다.
        </div>
      </div>
    </div>
    <!-- 문의하기 버튼 -->
    <div style="position: fixed; z-index: 1; bottom: 0px; left: 0px; width: 100%; height: calc(56px + 24px + 24px); padding: 0px 24px; background: linear-gradient(rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 15.1%, rgb(255, 255, 255) 100%)"
      class="d-flex align-center justify-center"
    >
      <div @click="clickContactBtnInDialog()"
        class="default-gradient-theme-btn d-flex align-center justify-center"
        style="height: 56px; width: 100%"
        :style="
          contactDialog_answerPath && 
          (contactDialog_answerPath !== '전화' || (contactDialog_answerPath === '전화' && contactDialog_ableTimeInput)) && 
          contactDialog_contactInput && 
          contactDialog_privacyPolicy
          ? {} 
          : {pointerEvents: 'none', cursor: 'none', opacity: '0.4'}
        "
      >
        <div style="font-size: 18px; font-weight: 700; line-height: 22px; color: #ffffff">
          문의하기
        </div>
      </div>
    </div>
  </div>

  <!-- 리컬럼 소개서 받아보기 dialog (web) -->
  <v-dialog v-if="window_innerWidth > 440" v-model="manualDownloadDialog" max-width="420px">
    <v-card style="height: 90vh; max-height: 782px; padding: 24px 22px 24px 22px; position: relative">
      <!-- 취소 버튼 -->
      <div @click="manualDownloadDialog = false"
        class="default-icon-btn d-flex align-center justify-center"
        style="position: absolute; top: 8px; right: 8px; width: 40px; height: 40px"
      >
        <v-icon style="font-size: 20px; color: #8A8DA8">
          mdi-close
        </v-icon>
      </div>
      <!-- title -->
      <div style="font-weight: 700; font-size: 18px; line-height: 24px; color: #0D0E17; margin-bottom: 24px; padding-left: 8px">
        리컬럼 소개서 받아보기
      </div>
      <!-- content (scroll) -->
      <div class="y-scroll-width-4px" style="overflow: hidden auto; height: calc(100% - 48px - 56px); padding: 0px 8px; mask-image: linear-gradient(to bottom, #ffffff 90%, transparent 100%)">
        <!-- 언어 버전 title -->
        <div style="padding-left: 2px; font-weight: 500; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 8px">
          언어 버전
        </div>
        <!-- 언어 버전 dropdown -->
        <div style="width: 100%; height: 40px; margin-bottom: 16px">
          <v-menu offset-y bottom>
            <!-- 선택값 -->
            <template v-slot:activator="{ on, value }">
              <div v-on="on" style="width: 100%; height: 100%; position: relative; cursor: pointer">
                <!-- 선택값 및 아이콘 -->
                <div class="d-flex align-center justify-space-between"
                  style="width: 100%; height: 100%; overflow: auto hidden; padding: 0px 8px 0px 12px; border-radius: 8px; border: 1px solid #E8EAF2; cursor: pointer"
                >
                  <!-- 선택값 -->
                  <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458; width: 100%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                    {{ manualDownloadDialog_language }}
                  </div>
                  <!-- 아이콘 -->
                  <v-icon :class="value ? 'up' : 'down'" style="font-size: 20px; color: #414458">
                    mdi-chevron-down
                  </v-icon>
                </div>
              </div>
            </template>
            <!-- 선택 목록 -->
            <v-card style="width: 100%; overflow: hidden auto">
              <!-- 한글(KOR) -->
              <div @click="manualDownloadDialog_language = '한글(KOR)'"
                class="hover-bg-color-F8F9FB d-flex align-center" style="height: 40px; padding: 0px 12px; cursor: pointer"
                :style="manualDownloadDialog_language === '한글(KOR)' ? {backgroundColor: '#F0F2FF'} : {}"
              >
                <!-- text -->
                <div style="font-size: 14px; font-weight: 500; line-height: 20px; color: #414458"
                  :style="manualDownloadDialog_language === '한글(KOR)' ? {color: '#687EFF', fontWeight: 600} : {}"
                >
                  한글(KOR)
                </div>
              </div>
              <!-- 영어(ENG) -->
              <div @click="manualDownloadDialog_language = '영어(ENG)'"
                class="hover-bg-color-F8F9FB d-flex align-center" style="height: 40px; padding: 0px 12px; cursor: pointer"
                :style="manualDownloadDialog_language === '영어(ENG)' ? {backgroundColor: '#F0F2FF'} : {}"
              >
                <!-- text -->
                <div style="font-size: 14px; font-weight: 500; line-height: 20px; color: #414458"
                  :style="manualDownloadDialog_language === '영어(ENG)' ? {color: '#687EFF', fontWeight: 600} : {}"
                >
                  영어(ENG)
                </div>
              </div>
            </v-card>
          </v-menu>
        </div>
        <!-- 이름 title -->
        <div style="padding-left: 2px; font-weight: 500; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 8px">
          이름
        </div>
        <!-- 이름 입력창 (로그인 o) -->
        <div v-if="$store.getters.isLoggedIn" class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #F8F9FB; margin-bottom: 16px">
          <div style="font-weight: 400; font-size: 14px; line-height: 18px; color: #ABAEC4">
            {{ $store.state.user_info.name }}
          </div>
        </div>
        <!-- 이름 입력창 (로그인 x) -->
        <div v-if="!$store.getters.isLoggedIn" class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #ffffff; margin-bottom: 16px">
          <input v-model="manualDownloadDialog_nameInput" ref="manualDownloadDialog_nameInput" type="text"
            :placeholder="nameInputFocused ? '' : '홍길동'"
            @focus="nameInputFocused = true" @blur="nameInputFocused = false"
            class="input-area" style="width: 100%; height: 100%; font-size: 14px; font-weight: 400; line-height: 18px; color: #414458"
          >
        </div>
        <!-- 업무용 이메일 title -->
        <div style="padding-left: 2px; font-weight: 500; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 8px">
          업무용 이메일
        </div>
        <!-- 업무용 이메일 입력창 (로그인 o) -->
        <div v-if="$store.getters.isLoggedIn" class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #F8F9FB; margin-bottom: 16px">
          <div style="font-weight: 400; font-size: 14px; line-height: 18px; color: #ABAEC4">
            {{ $store.state.user_info.email }}
          </div>
        </div>
        <!-- 업무용 이메일 입력창 (로그인 x) -->
        <div v-if="!$store.getters.isLoggedIn" class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #ffffff; margin-bottom: 16px">
          <input v-model="manualDownloadDialog_emailInput" ref="manualDownloadDialog_emailInput" type="text"
            :placeholder="emailInputFocused ? '' : 'contact@cogcom.kr'"
            @focus="emailInputFocused = true" @blur="emailInputFocused = false"
            class="input-area" style="width: 100%; height: 100%; font-size: 14px; font-weight: 400; line-height: 18px; color: #414458"
          >
        </div>
        <!-- 회사 title -->
        <div style="padding-left: 2px; font-weight: 500; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 8px">
          회사
        </div>
        <!-- 회사 입력창 -->
        <div class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #ffffff; margin-bottom: 16px">
          <input v-model="manualDownloadDialog_companyInput" ref="manualDownloadDialog_companyInput" type="text" 
            :placeholder="companyInputFocused ? '' : '(주)리컬럼'"
            @focus="companyInputFocused = true" @blur="companyInputFocused = false"
            class="input-area" style="width: 100%; height: 100%; font-size: 14px; font-weight: 400; line-height: 18px; color: #414458"
          >
        </div>
        <!-- 직책 title -->
        <div style="padding-left: 2px; font-weight: 500; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 8px">
          직책
        </div>
        <!-- 직책 입력창 -->
        <div class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #ffffff; margin-bottom: 16px">
          <input v-model="manualDownloadDialog_positionInput" ref="manualDownloadDialog_positionInput" type="text" 
            :placeholder="positionInputFocused ? '' : '팀장'"
            @focus="positionInputFocused = true" @blur="positionInputFocused = false"
            class="input-area" style="width: 100%; height: 100%; font-size: 14px; font-weight: 400; line-height: 18px; color: #414458"
          >
        </div>
        <!-- 연락처 title -->
        <div style="padding-left: 2px; font-weight: 500; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 8px">
          연락처
        </div>
        <!-- 연락처 입력창 -->
        <div class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #ffffff; margin-bottom: 10px">
          <input v-model="manualDownloadDialog_phoneNumberInput" ref="manualDownloadDialog_phoneNumberInput" type="text" 
            :placeholder="phoneNumberInputFocused ? '' : '010-1234-5678'"
            @focus="phoneNumberInputFocused = true" @blur="phoneNumberInputFocused = false"
            class="input-area" style="width: 100%; height: 100%; font-size: 14px; font-weight: 400; line-height: 18px; color: #414458"
          >
        </div>
        <!-- 마케팅 정보 수신에 동의합니다. -->
        <div class="d-flex align-start" style="width: 100%; margin-bottom: 10px; transform: translateX(-8px)">
          <div class="checkbox-btn d-flex align-center justify-center" style="min-width: 36px; height: 36px; transform: translateY(-2px)" @click="manualDownloadDialog_marketingReception = !manualDownloadDialog_marketingReception">
            <v-icon v-if="manualDownloadDialog_marketingReception" style="font-size: 18px; color: #687EFF">
              mdi-checkbox-marked
            </v-icon>
            <v-icon v-else style="font-size: 18px; color: #D8DAE9">
              mdi-checkbox-blank-outline
            </v-icon>
          </div>
          <div>
            <div style="font-size: 14px; font-weight: 400; line-height: 32px; color: #414458">
              마케팅 정보 수신에 동의합니다.
            </div>
            <div style="font-size: 13px; font-weight: 400; line-height: 18px; color: #8A8DA8; word-break: keep-all">
              마케팅 정보 수신에 동의하시면 이후 업무에 도움이 되는 최신 자동화 트렌드와 사례 자료를 받으실 수 있습니다.
            </div>
          </div>
        </div>
        <!-- 개인정보처리방침에 동의합니다. -->
        <div class="d-flex align-center" style="width: 100%; margin-bottom: 30px; transform: translateX(-8px)">
          <div class="checkbox-btn d-flex align-center justify-center" style="width: 36px; height: 36px" @click="manualDownloadDialog_privacyPolicy = !manualDownloadDialog_privacyPolicy">
            <v-icon v-if="manualDownloadDialog_privacyPolicy" style="font-size: 18px; color: #687EFF">
              mdi-checkbox-marked
            </v-icon>
            <v-icon v-else style="font-size: 18px; color: #D8DAE9">
              mdi-checkbox-blank-outline
            </v-icon>
          </div>
          <div style="font-size: 14px; font-weight: 400; line-height: 18px; color: #414458">
            <span style="cursor: pointer; text-decoration: underline" @click="openPrivacyPolicy()">개인정보처리방침</span>에 동의합니다.
          </div>
        </div>
      </div>
      <!-- 리컬럼 소개서 다운로드 버튼 -->
      <div class="d-flex align-center justify-center">
        <div @click="clickManualDownloadBtn()"
          class="default-gradient-theme-btn d-flex align-center justify-center"
          style="height: 56px; width: 360px"
          :style="
            ($store.state.user_info.name || manualDownloadDialog_nameInput) && ($store.state.user_info.email || manualDownloadDialog_emailInput) &&
            manualDownloadDialog_companyInput && manualDownloadDialog_positionInput && manualDownloadDialog_phoneNumberInput && manualDownloadDialog_privacyPolicy ?
            {} : {pointerEvents: 'none', cursor: 'none', opacity: '0.4'}
          "
        >
          <div style="font-size: 18px; font-weight: 700; line-height: 22px; color: #ffffff">
            리컬럼 소개서 다운로드
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
  <!-- 리컬럼 소개서 받아보기 (mobile) -->
  <div v-if="manualDownloadDialog && window_innerWidth <= 440" style="position: relative; width: 100vw; background-color: #ffffff"
    :style="top_alert ? {marginTop: `calc(${top_alert_height} + 60px)`} : {marginTop: '60px'}"
  >
    <!-- 상단 영역 (title, 취소 버튼) -->
    <div style="position: fixed; z-index: 1; width: 100%; padding: 24px; background-color: #ffffff" :style="top_alert ? {top: `calc(${top_alert_height} + 60px)`} : {top: '60px'}">
      <!-- 취소 버튼 -->
      <div @click="manualDownloadDialog = false"
        class="default-icon-btn d-flex align-center justify-center"
        style="position: absolute; top: 8px; right: 8px; width: 40px; height: 40px"
      >
        <v-icon style="font-size: 20px; color: #8A8DA8">
          mdi-close
        </v-icon>
      </div>
      <!-- title -->
      <div style="font-weight: 700; font-size: 18px; line-height: 24px; color: #0D0E17">
        리컬럼 소개서 받아보기
      </div>
    </div>
    <!-- content -->
    <div style="padding: 72px 24px 104px">
      <!-- 언어 버전 title -->
      <div style="padding-left: 2px; font-weight: 500; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 8px">
        언어 버전
      </div>
      <!-- 언어 버전 dropdown -->
      <div style="width: 100%; height: 40px; margin-bottom: 16px">
        <v-menu offset-y bottom>
          <!-- 선택값 -->
          <template v-slot:activator="{ on, value }">
            <div v-on="on" style="width: 100%; height: 100%; position: relative; cursor: pointer">
              <!-- 선택값 및 아이콘 -->
              <div class="d-flex align-center justify-space-between"
                style="width: 100%; height: 100%; overflow: auto hidden; padding: 0px 8px 0px 12px; border-radius: 8px; border: 1px solid #E8EAF2; cursor: pointer"
              >
                <!-- 선택값 -->
                <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458; width: 100%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                  {{ manualDownloadDialog_language }}
                </div>
                <!-- 아이콘 -->
                <v-icon :class="value ? 'up' : 'down'" style="font-size: 20px; color: #414458">
                  mdi-chevron-down
                </v-icon>
              </div>
            </div>
          </template>
          <!-- 선택 목록 -->
          <v-card style="width: 100%; overflow: hidden auto">
            <!-- 한글(KOR) -->
            <div @click="manualDownloadDialog_language = '한글(KOR)'"
              class="hover-bg-color-F8F9FB d-flex align-center" style="height: 40px; padding: 0px 12px; cursor: pointer"
              :style="manualDownloadDialog_language === '한글(KOR)' ? {backgroundColor: '#F0F2FF'} : {}"
            >
              <!-- text -->
              <div style="font-size: 14px; font-weight: 500; line-height: 20px; color: #414458"
                :style="manualDownloadDialog_language === '한글(KOR)' ? {color: '#687EFF', fontWeight: 600} : {}"
              >
                한글(KOR)
              </div>
            </div>
            <!-- 영어(ENG) -->
            <div @click="manualDownloadDialog_language = '영어(ENG)'"
              class="hover-bg-color-F8F9FB d-flex align-center" style="height: 40px; padding: 0px 12px; cursor: pointer"
              :style="manualDownloadDialog_language === '영어(ENG)' ? {backgroundColor: '#F0F2FF'} : {}"
            >
              <!-- text -->
              <div style="font-size: 14px; font-weight: 500; line-height: 20px; color: #414458"
                :style="manualDownloadDialog_language === '영어(ENG)' ? {color: '#687EFF', fontWeight: 600} : {}"
              >
                영어(ENG)
              </div>
            </div>
          </v-card>
        </v-menu>
      </div>
      <!-- 이름 title -->
      <div style="padding-left: 2px; font-weight: 500; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 8px">
        이름
      </div>
      <!-- 이름 입력창 (로그인 o) -->
      <div v-if="$store.getters.isLoggedIn" class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #F8F9FB; margin-bottom: 16px">
        <div style="font-weight: 400; font-size: 14px; line-height: 18px; color: #ABAEC4">
          {{ $store.state.user_info.name }}
        </div>
      </div>
      <!-- 이름 입력창 (로그인 x) -->
      <div v-if="!$store.getters.isLoggedIn" class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #ffffff; margin-bottom: 16px">
        <input v-model="manualDownloadDialog_nameInput" ref="manualDownloadDialog_nameInput" type="text"
          :placeholder="nameInputFocused ? '' : '홍길동'"
          @focus="nameInputFocused = true" @blur="nameInputFocused = false"
          class="input-area" style="width: 100%; height: 100%; font-size: 14px; font-weight: 400; line-height: 18px; color: #414458"
        >
      </div>
      <!-- 업무용 이메일 title -->
      <div style="padding-left: 2px; font-weight: 500; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 8px">
        업무용 이메일
      </div>
      <!-- 업무용 이메일 입력창 (로그인 o) -->
      <div v-if="$store.getters.isLoggedIn" class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #F8F9FB; margin-bottom: 16px">
        <div style="font-weight: 400; font-size: 14px; line-height: 18px; color: #ABAEC4">
          {{ $store.state.user_info.email }}
        </div>
      </div>
      <!-- 업무용 이메일 입력창 (로그인 x) -->
      <div v-if="!$store.getters.isLoggedIn" class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #ffffff; margin-bottom: 16px">
        <input v-model="manualDownloadDialog_emailInput" ref="manualDownloadDialog_emailInput" type="text"
          :placeholder="emailInputFocused ? '' : 'contact@cogcom.kr'"
          @focus="emailInputFocused = true" @blur="emailInputFocused = false"
          class="input-area" style="width: 100%; height: 100%; font-size: 14px; font-weight: 400; line-height: 18px; color: #414458"
        >
      </div>
      <!-- 회사 title -->
      <div style="padding-left: 2px; font-weight: 500; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 8px">
        회사
      </div>
      <!-- 회사 입력창 -->
      <div class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #ffffff; margin-bottom: 16px">
        <input v-model="manualDownloadDialog_companyInput" ref="manualDownloadDialog_companyInput" type="text" 
          :placeholder="companyInputFocused ? '' : '(주)리컬럼'"
          @focus="companyInputFocused = true" @blur="companyInputFocused = false"
          class="input-area" style="width: 100%; height: 100%; font-size: 14px; font-weight: 400; line-height: 18px; color: #414458"
        >
      </div>
      <!-- 직책 title -->
      <div style="padding-left: 2px; font-weight: 500; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 8px">
        직책
      </div>
      <!-- 직책 입력창 -->
      <div class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #ffffff; margin-bottom: 16px">
        <input v-model="manualDownloadDialog_positionInput" ref="manualDownloadDialog_positionInput" type="text" 
          :placeholder="positionInputFocused ? '' : '팀장'"
          @focus="positionInputFocused = true" @blur="positionInputFocused = false"
          class="input-area" style="width: 100%; height: 100%; font-size: 14px; font-weight: 400; line-height: 18px; color: #414458"
        >
      </div>
      <!-- 연락처 title -->
      <div style="padding-left: 2px; font-weight: 500; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 8px">
        연락처
      </div>
      <!-- 연락처 입력창 -->
      <div class="d-flex align-center" style="width: 100%; height: 40px; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 16px; background-color: #ffffff; margin-bottom: 10px">
        <input v-model="manualDownloadDialog_phoneNumberInput" ref="manualDownloadDialog_phoneNumberInput" type="text" 
          :placeholder="phoneNumberInputFocused ? '' : '010-1234-5678'"
          @focus="phoneNumberInputFocused = true" @blur="phoneNumberInputFocused = false"
          class="input-area" style="width: 100%; height: 100%; font-size: 14px; font-weight: 400; line-height: 18px; color: #414458"
        >
      </div>
      <!-- 마케팅 정보 수신에 동의합니다. -->
      <div class="d-flex align-start" style="width: 100%; margin-bottom: 10px; transform: translateX(-8px)">
        <div class="checkbox-btn d-flex align-center justify-center" style="min-width: 36px; height: 36px; transform: translateY(-2px)" @click="manualDownloadDialog_marketingReception = !manualDownloadDialog_marketingReception">
          <v-icon v-if="manualDownloadDialog_marketingReception" style="font-size: 18px; color: #687EFF">
            mdi-checkbox-marked
          </v-icon>
          <v-icon v-else style="font-size: 18px; color: #D8DAE9">
            mdi-checkbox-blank-outline
          </v-icon>
        </div>
        <div>
          <div style="font-size: 14px; font-weight: 400; line-height: 32px; color: #414458">
            마케팅 정보 수신에 동의합니다.
          </div>
          <div style="font-size: 13px; font-weight: 400; line-height: 18px; color: #8A8DA8; word-break: keep-all">
            마케팅 정보 수신에 동의하시면 이후 업무에 도움이 되는 최신 자동화 트렌드와 사례 자료를 받으실 수 있습니다.
          </div>
        </div>
      </div>
      <!-- 개인정보처리방침에 동의합니다. -->
      <div class="d-flex align-center" style="width: 100%; margin-bottom: 0px; transform: translateX(-8px)">
        <div class="checkbox-btn d-flex align-center justify-center" style="width: 36px; height: 36px" @click="manualDownloadDialog_privacyPolicy = !manualDownloadDialog_privacyPolicy">
          <v-icon v-if="manualDownloadDialog_privacyPolicy" style="font-size: 18px; color: #687EFF">
            mdi-checkbox-marked
          </v-icon>
          <v-icon v-else style="font-size: 18px; color: #D8DAE9">
            mdi-checkbox-blank-outline
          </v-icon>
        </div>
        <div style="font-size: 14px; font-weight: 400; line-height: 18px; color: #414458">
          <span style="cursor: pointer; text-decoration: underline" @click="openPrivacyPolicy()">개인정보처리방침</span>에 동의합니다.
        </div>
      </div>
    </div>
    <!-- 리컬럼 소개서 다운로드 버튼 -->
    <div style="position: fixed; z-index: 1; bottom: 0px; left: 0px; width: 100%; height: calc(56px + 24px + 24px); padding: 0px 24px; background: linear-gradient(rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 15.1%, rgb(255, 255, 255) 100%)"
      class="d-flex align-center justify-center"
    >
      <div @click="clickManualDownloadBtn()" style="height: 56px; width: 100%"
        class="default-gradient-theme-btn d-flex align-center justify-center"
        :style="
          ($store.state.user_info.name || manualDownloadDialog_nameInput) && ($store.state.user_info.email || manualDownloadDialog_emailInput) &&
          manualDownloadDialog_companyInput && manualDownloadDialog_positionInput && manualDownloadDialog_phoneNumberInput && manualDownloadDialog_privacyPolicy ?
          {} : {pointerEvents: 'none', cursor: 'none', opacity: '0.4'}
        "
      >
        <div style="font-size: 18px; font-weight: 700; line-height: 22px; color: #ffffff">
          리컬럼 소개서 다운로드
        </div>
      </div>
    </div>
  </div>

  <!-- 무료체험 요청 dialog -->
  <v-dialog v-model="demoRequestDialog" max-width="440px">
    <v-card v-if="demoRequestDialog" style="border-radius: 10px; position: relative">
      <!-- 취소 버튼 -->
      <div @click="demoRequestDialog = false"
        class="default-icon-btn d-flex align-center justify-center"
        style="position: absolute; top: 14px; right: 14px; width: 32px; height: 32px"
      >
        <v-icon style="font-size: 24px; color: #8A8DA8">
          mdi-close
        </v-icon>
      </div>
      <!-- 이메일 발송 전 -->
      <div v-if="sendTrialEmailFlag === 0" class="d-flex flex-column align-center" style="padding: 40px">
        <!-- 리컬럼 로고 -->
        <div class="d-flex align-center" style="margin-bottom: 14px">
          <!-- logo -->
          <img src="/assets/recolumn-logo.svg" style="width: 15px; height: 23px; object-fit: contain; margin-right: 8px">
          <!-- title -->
          <div style="font-size: 24px; font-weight: 600; line-height: 100%; color: #0D0E17; letter-spacing: -0.02em">
            Re:Column
          </div>
        </div>
        <!-- text -->
        <div style="text-align: center; font-size: 16px; font-weight: 500; line-height: 18px; color: #414458; margin-bottom: 32px">
          2주간 리컬럼의 데이터 업무 자동화를 체험해 보세요!
        </div>
        <!-- 이메일 입력창 -->
        <v-text-field v-model="emailInput" placeholder="이메일을 입력하세요." autofocus
          height="48px" background-color="#FFFFFF" color="#0D0E17" outlined dense hide-details
          class="default-input" style="width: 100%; border-radius: 8px; font-size: 16px; margin-bottom: 24px"
        ></v-text-field>
        <!-- 2주 무료체험 버튼 -->
        <div @click="clickTrialBtn(emailInput)"
          class="default-gradient-theme-btn d-flex align-center justify-center"
          :class="checkEmailValid(emailInput) ? '' : 'disabled-area-opacity-40'"
          style="height: 56px; width: 100%"
        >
          <div style="font-size: 18px; line-height: 22px; padding-left: 4px">
            2주 무료체험
          </div>
          <v-icon style="font-size: 24px; margin-left: 4px">
            mdi-arrow-right
          </v-icon>
        </div>
      </div>
      <!-- 이메일 발송 후 - 무료체험 신청 기록이 없는 경우 -->
      <div v-if="sendTrialEmailFlag === 1" class="d-flex flex-column align-center" style="padding: 40px 35px 52px">
        <!-- 리컬럼 로고 -->
        <div class="d-flex align-center" style="margin-bottom: 24px">
          <!-- logo -->
          <img src="/assets/recolumn-logo.svg" style="width: 15px; height: 23px; object-fit: contain; margin-right: 8px">
          <!-- title -->
          <div style="font-size: 24px; font-weight: 600; line-height: 100%; color: #0D0E17; letter-spacing: -0.02em">
            Re:Column
          </div>
        </div>
        <!-- title -->
        <div style="font-size: 27px; font-weight: 700; line-height: 38px; color: #414458; text-align: center; margin-bottom: 24px">
          곧 무료체험이 시작됩니다.
        </div>
        <!-- text -->
        <div style="font-size: 14px; font-weight: 400; line-height: 20px; color: #8A8DA8; text-align: center; margin-bottom: 14px">
          잠시 기다려주시면 1 영업일 이내에 <br> 입력하신 이메일 계정으로 무료체험 링크를 보내드립니다.
        </div>
        <!-- text -->
        <div style="font-size: 14px; font-weight: 400; line-height: 20px; color: #8A8DA8; text-align: center">
          문사항은 고객센터로 연락주세요. <br> (<span style="text-decoration: underline">contact@cogcom.kr</span>, <span style="text-decoration: underline">02-2088-2096</span>)
        </div>
      </div>
      <!-- 이메일 발송 후 - 무료체험 신청 기록이 있는 경우 -->
      <div v-if="sendTrialEmailFlag === 2" class="d-flex flex-column align-center" style="padding: 40px">
        <!-- 리컬럼 로고 -->
        <div class="d-flex align-center" style="margin-bottom: 24px">
          <!-- logo -->
          <img src="/assets/recolumn-logo.svg" style="width: 15px; height: 23px; object-fit: contain; margin-right: 8px">
          <!-- title -->
          <div style="font-size: 24px; font-weight: 600; line-height: 100%; color: #0D0E17; letter-spacing: -0.02em">
            Re:Column
          </div>
        </div>
        <!-- title -->
        <div style="font-size: 27px; font-weight: 700; line-height: 38px; color: #414458; text-align: center; margin-bottom: 24px">
          무료체험을 연장하고 싶으신가요?
        </div>
        <!-- text -->
        <div style="font-size: 14px; font-weight: 400; line-height: 20px; color: #8A8DA8; text-align: center; margin-bottom: 30px">
          채널톡을 통해 상담을 진행하실 수 있습니다. <br> 문의를 남겨주시면 몇 분 내로 상담사가 직접 응대해 드립니다.
        </div>
        <!-- 리컬럼 매니저 -->
        <div class="d-flex align-center"
          style="width: 300px; height: 56px; border-radius: 10px; border: 1px solid #F8F9FB; box-shadow: 2.11px 4.23px 4.23px 0px #41445829; padding: 0px 10px; margin-bottom: 32px"
        >
          <!-- avatar -->
          <v-avatar color="#D8DDFF" size="34" style="margin-right: 10px">
            <v-icon style="font-size: 20px; color: #ffffff">
              mdi-account
            </v-icon>
          </v-avatar>
          <!-- title / sub -->
          <div>
            <!-- title -->
            <div style="font-weight: 600; font-size: 14px; line-height: 18px; color: #414458; margin-bottom: 2px">
              리컬럼 매니저
            </div>
            <!-- sub -->
            <div style="font-weight: 400; font-size: 13px; line-height: 16px; color: #8A8DA8">
              9:00 AM ~ 5:00 PM
            </div>
          </div>
        </div>
        <!-- 채널톡으로 문의하기 버튼 -->
        <div @click="contactChannelTalk()"
          class="default-gradient-theme-btn d-flex align-center justify-center"
          style="height: 56px; width: 100%; border-radius: 10px !important"
        >
          <div style="font-size: 18px; line-height: 22px">
            채널톡으로 문의하기
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>

  <!-- 튜토리얼 시작 dialog -->
  <v-dialog v-model="tutorialStartDialog" max-width="556px">
    <v-card style="border-radius: 10px; padding: 22px 28px 24px; position: relative">
      <!-- 취소 버튼 -->
      <div @click="tutorialStartDialog = false"
        class="default-icon-btn d-flex align-center justify-center"
        style="position: absolute; top: 6px; right: 8px; width: 40px; height: 40px"
      >
        <v-icon style="font-size: 20px; color: #8A8DA8 !important">
          mdi-close
        </v-icon>
      </div>
      <!-- title -->
      <div style="font-size: 18px; font-weight: 600; line-height: 24px; color: #0D0E17; margin-bottom: 4px">
        튜토리얼 시작
      </div>
      <!-- sub -->
      <div style="font-size: 14px; font-weight: 500; line-height: 20px; color: #8A8DA8; margin-bottom: 24px">
        튜토리얼을 선택하면 해당 튜토리얼 시작 화면으로 이동하게 됩니다. 작업 중이던 내용이 있다면 작업을 완료한 후 진행해주세요.
      </div>
      <!-- 기본 튜토리얼 -->
      <div @click="clickBasicTutorial()"
        class="tutorial-start-dialog-item d-flex align-center" style="width: 100%; height: 56px; border-radius: 8px; padding: 0px 8px; cursor: pointer; margin-bottom: 8px"
      >
        <!-- icon box -->
        <div class="d-flex align-center justify-center" style="min-width: 60px; height: 42px; border-radius: 8px; background-color: #F0F2FF">
          <v-icon style="font-size: 24px; color: #687EFF">
            mdi-rocket-outline
          </v-icon>
        </div>
        <!-- text box -->
        <div style="margin-left: 10px">
          <div style="font-size: 15px; font-weight: 600; line-height: 18px; color: #414458; margin-bottom: 4px">
            기본 튜토리얼
          </div>
          <div style="font-size: 13px; font-weight: 400; line-height: 16px; color: #8A8DA8">
            프로젝트 접속부터, 자동화 결과물 엑셀 파일 생성까지 안내합니다.
          </div>
        </div>
      </div>
      <!-- 워크플로우 프로세스 둘러보기 -->
      <div @click="clickRpaTutorial()"
        class="tutorial-start-dialog-item d-flex align-center" style="width: 100%; height: 56px; border-radius: 8px; padding: 0px 8px; cursor: pointer; margin-bottom: 8px"
      >
        <!-- icon box -->
        <div class="d-flex align-center justify-center" style="min-width: 60px; height: 42px; border-radius: 8px; background-color: #F0F2FF">
          <v-icon style="font-size: 24px; color: #687EFF">
            mdi-refresh-auto
          </v-icon>
        </div>
        <!-- text box -->
        <div style="margin-left: 10px">
          <div style="font-size: 15px; font-weight: 600; line-height: 18px; color: #414458; margin-bottom: 4px">
            워크플로우 프로세스 둘러보기
          </div>
          <div style="font-size: 13px; font-weight: 400; line-height: 16px; color: #8A8DA8">
            리컬럼 워크플로우가 어떻게 구성되어 있는지 안내합니다.
          </div>
        </div>
      </div>
      <!-- 데이터 보기 모드 및 서식 보기 모드 -->
      <div @click="clickDataModeTutorial()"
        class="tutorial-start-dialog-item d-flex align-center" style="width: 100%; height: 56px; border-radius: 8px; padding: 0px 8px; cursor: pointer; margin-bottom: 8px"
      >
        <!-- icon box -->
        <div class="d-flex align-center justify-center" style="min-width: 60px; height: 42px; border-radius: 8px; background-color: #F0F2FF">
          <v-icon style="font-size: 24px; color: #687EFF">
            mdi-palette-outline
          </v-icon>
        </div>
        <!-- text box -->
        <div style="margin-left: 10px">
          <div style="font-size: 15px; font-weight: 600; line-height: 18px; color: #414458; margin-bottom: 4px">
            데이터 보기 모드 및 서식 보기 모드
          </div>
          <div style="font-size: 13px; font-weight: 400; line-height: 16px; color: #8A8DA8">
            스프레드시트 형식 파일들의 서식 보기, 필터 및 정렬 방법을 안내합니다.
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>

  <!-- 로그인 dialog -->
  <v-dialog v-model="loginDialog" max-width="440px">
    <v-card v-if="loginDialog" class="d-flex flex-column align-center justify-center" style="padding: 0px 40px; border-radius: 10px; position: relative">
      <!-- close btn -->
      <div @click="loginDialog = false"
        class="default-icon-btn d-flex align-center justify-center"
        style="width: 32px; height: 32px; position: absolute; top: 14px; right: 14px"
      >
        <v-icon style="font-size: 24px">
          mdi-close
        </v-icon>
      </div>
      <!-- logo 및 title -->
      <div class="d-flex align-center justify-center" style="padding: 42px 0px 30px 0px">
        <!-- logo -->
        <img src="/assets/recolumn-logo.svg" style="width: 15px; height: 23px; object-fit: contain; margin-right: 8px">
        <!-- title -->
        <div style="font-size: 24px; font-weight: 600; line-height: 100%; color: #0D0E17; letter-spacing: -0.02em">
          Re:Column
        </div>
      </div>
      <!-- email input -->
      <div style="width: 100%; margin-bottom: 12px">
        <v-text-field
          v-model="userEmailInput" placeholder="이메일을 입력하세요." autofocus
          height="40px" background-color="#FFFFFF" color="#0D0E17" outlined dense hide-details
          class="text-input text-input-px-4" style="border-radius: 8px; font-size: 14px"
        ></v-text-field>
      </div>
      <!-- password input -->
      <div style="width: 100%; margin-bottom: 28px">
        <v-text-field @keyup.enter="commonLogin(userEmailInput, userPasswordInput)"
          v-model="userPasswordInput" placeholder="비밀번호를 입력하세요."
          :type="showUserPasswordInput ? 'text' : 'password'" :append-icon="showUserPasswordInput ? 'mdi-eye-outline' : 'mdi-eye-off-outline'" @click:append="showUserPasswordInput = !showUserPasswordInput"
          height="40px" background-color="#FFFFFF" color="#D8DAE9" outlined dense hide-details
          class="text-input text-input-px-4" style="border-radius: 8px; font-size: 14px"
        ></v-text-field>
      </div>
      <!-- login btn -->
      <div @click="commonLogin(userEmailInput, userPasswordInput)"
        class="default-theme-btn d-flex align-center justify-center"
        style="width: 100%; height: 40px; margin-bottom: 12px"
      >
        <div style="font-size: 14px; font-weight: 600; line-height: 18px">
          로그인
        </div>
      </div>
      <!-- 비밀번호 찾기 -->
      <div @click="findPasswordDialog = true; userEmailInput = ''; loginDialog = false"
        style="font-size: 14px; font-weight: 400; line-height: 18px; color: #ABAEC4; cursor: pointer; margin-bottom: 36px"
      >
        비밀번호 찾기
      </div>
      <!-- 간편 로그인 -->
      <div class="d-flex align-center" style="position: relative; width: 100%; height: 18px; margin-bottom: 11px">
        <!-- line -->
        <div
          style="width: 100%; height: 1px; background-color: #E8EAF2"
        ></div>
        <!-- title -->
        <div style="position: absolute; top: 0; left: calc(50% - 44px); background-color: #FFFFFF; padding: 0px 11px 0px 12px">
          <div style="font-size: 14px; font-weight: 400; line-height: 18px; color: #8A8DA8">
            간편 로그인
          </div>
        </div>
      </div>
      <!-- google login btn -->
      <div @click="googleSocialLogin()"
        class="default-white-btn d-flex align-center justify-center"
        style="width: 100%; height: 40px; margin-bottom: 40px"
      >
        <v-img
          src="/assets/google-logo.png" max-width="24px" max-height="24px"
        ></v-img>
        <span style="font-size: 14px; font-weight: 500; line-height: 18px; margin-left: 8px">
          Google 계정으로 로그인
        </span>
      </div>
    </v-card>
  </v-dialog>

  <!-- 비밀번호 찾기 dialog -->
  <v-dialog v-model="findPasswordDialog" max-width="440px">
    <v-card class="d-flex flex-column align-center justify-center" style="padding: 0px 40px; border-radius: 10px; position: relative">
      <!-- close btn -->
      <div @click="findPasswordDialog = false"
        class="default-icon-btn d-flex align-center justify-center"
        style="width: 32px; height: 32px; position: absolute; top: 14px; right: 14px"
      >
        <v-icon style="font-size: 24px">
          mdi-close
        </v-icon>
      </div>
      <!-- logo 및 title -->
      <div class="d-flex align-center justify-center" style="padding: 42px 0px 30px 0px">
        <!-- logo -->
        <img src="/assets/recolumn-logo.svg" style="width: 15px; height: 23px; object-fit: contain; margin-right: 8px">
        <!-- title -->
        <div style="font-size: 24px; font-weight: 600; line-height: 100%; color: #0D0E17; letter-spacing: -0.02em">
          Re:Column
        </div>
      </div>
      <!-- email input -->
      <div style="width: 100%; margin-bottom: 12px">
        <v-text-field
          v-model="userEmailInput" placeholder="가입했던 이메일을 입력하세요." autofocus
          height="40px" background-color="#FFFFFF" color="#0D0E17" outlined dense hide-details
          class="text-input text-input-px-4" style="border-radius: 8px; font-size: 14px"
        ></v-text-field>
      </div>
      <!-- 하단 문구 -->
      <div style="width: 100%; padding-left: 4px; margin-bottom: 28px">
        <div style="font-size: 14px; font-weight: 400; line-height: 18px; color: #ABAEC4">
          새 비밀번호를 설정할 수 있는 링크가 전송됩니다.
        </div>
      </div>
      <!-- 이메일 발송 버튼 -->
      <div @click="sendFindPasswordEmail(userEmailInput)"
        class="default-theme-btn d-flex align-center justify-center"
        style="width: 100%; height: 40px; margin-bottom: 197px"
      >
        <div style="font-size: 14px; font-weight: 600; line-height: 18px">
          이메일 발송
        </div>
      </div>
    </v-card>
  </v-dialog>

  <!-- 사용 기한 만료 알림 dialog -->
  <v-dialog v-model="$store.state.dateExpirationDialog" max-width="500px">
    <v-card style="padding: 22px 28px 82px; position: relative">
      <!-- 취소 버튼(absolute) -->
      <div @click="$store.state.dateExpirationDialog = false"
        class="default-icon-btn d-flex align-center justify-center"
        style="position: absolute; top: 6px; right: 8px; width: 40px; height: 40px"
      >
        <v-icon style="font-size: 20px; color: #8A8DA8">
          mdi-close
        </v-icon>
      </div>
      <!-- title -->
      <div style="font-size: 18px; font-weight: 600; line-height: 24px; color: #0D0E17; margin-bottom: 4px">
        사용 기한이 만료된 계정입니다.
      </div>
      <!-- sub title -->
      <div style="font-size: 14px; font-weight: 500; line-height: 20px; color: #8A8DA8; margin-bottom: 24px">
        내용을 복사한 뒤 우측 하단의 채널톡에 전송해 간편하게 문의하실 수 있습니다.
      </div>
      <!-- 이름 title -->
      <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #8A8DA8; margin-bottom: 4px">
        이름
      </div>
      <!-- 이름 -->
      <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458; margin-bottom: 16px">
        {{ $store.state.user_info.name }}
      </div>
      <!-- 이메일 title -->
      <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #8A8DA8; margin-bottom: 4px">
        이메일
      </div>
      <!-- 이메일 -->
      <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458; margin-bottom: 16px">
        {{ $store.state.user_info.email }}
      </div>
      <!-- 조직 title -->
      <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #8A8DA8; margin-bottom: 4px">
        조직
      </div>
      <!-- 조직 -->
      <div class="d-flex align-center" style="margin-bottom: 16px">
        <!-- root -->
        <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
          {{ $store.state.user_info.organization_root_name }}
        </div>
        <!-- > -->
        <v-icon v-if="$store.state.user_info.organization_root !== $store.state.user_info.organization_sub"
          style="font-size: 18px; color: #8A8DA8; margin: 0px 2px"
        >
          mdi-chevron-right
        </v-icon>
        <!-- sub -->
        <div v-if="$store.state.user_info.organization_root !== $store.state.user_info.organization_sub"
          style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458"
        >
          {{ $store.state.user_info.organization_sub_name }}
        </div>
      </div>
      <!-- 만료일 title -->
      <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #8A8DA8; margin-bottom: 4px">
        만료일
      </div>
      <!-- 만료일 -->
      <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458; margin-bottom: 16px">
        {{ $store.state.user_info.paid_expire_date | dateFormatFilter }}
      </div>
      <!-- 내용 복사 버튼(absolute) -->
      <div @click="copyDateExpirationDialogContent()"
        class="default-theme-btn d-flex align-center"
        style="position: absolute; bottom: 20px; right: 20px; height: 30px; padding: 0px 12px 0px 10px"
      >
        <v-icon style="font-size: 20px">
          mdi-content-copy
        </v-icon>
        <span style="font-size: 14px; font-weight: 600; line-height: 18px; margin-left: 6px">
          내용 복사
        </span>
      </div>
    </v-card>
  </v-dialog>

  <!-- 비활성화 계정 알림 dialog -->
  <v-dialog v-model="$store.state.deactivatedAccountDialog" max-width="440px">
    <v-card class="d-flex flex-column align-center justify-center" style="border-radius: 10px; position: relative">
      <!-- 취소 버튼(absolute) -->
      <div @click="$store.state.deactivatedAccountDialog = false"
        class="default-icon-btn d-flex align-center justify-center"
        style="position: absolute; top: 14px; right: 14px; width: 32px; height: 32px"
      >
        <v-icon style="font-size: 24px; color: #8A8DA8">
          mdi-close
        </v-icon>
      </div>
      <!-- 리컬럼 로고 -->
      <div class="d-flex align-center justify-center" style="padding: 40px 0px 24px 0px">
        <!-- logo -->
        <img src="/assets/recolumn-logo-D8DAE9.svg" style="width: 15px; height: 23px; object-fit: contain; margin-right: 8px">
        <!-- title -->
        <div style="font-size: 24px; font-weight: 600; line-height: 100%; color: #D8DAE9; letter-spacing: -0.02em">
          Re:Column
        </div>
      </div>
      <!-- title -->
      <div style="font-size: 27px; font-weight: 700; line-height: 38px; color: #414458; margin-bottom: 24px">
        비활성화된 계정입니다.
      </div>
      <!-- sub title -->
      <div style="text-align: center; font-size: 14px; font-weight: 400; line-height: 20px; color: #8A8DA8; margin-bottom: 66px">
        내 조직 관리자, 혹은 리컬럼 관리자가 비활성화한 계정입니다. <br>
        계정 활성화가 필요하시면 내 조직 관리자에게 문의하시거나, <br>
        리컬럼 고객센터로 연락 바랍니다. <br>
        (<span style="text-decoration: underline">contact@cogcom.kr</span>, <span style="text-decoration: underline">02-2088-2096</span>)
      </div>
    </v-card>
  </v-dialog>

  <!-- 계정 활성화 dialog -->
  <v-dialog v-model="accountActivateDialog" max-width="600px">
    <v-card class="d-flex flex-column px-8 py-10" style="height: 400px">
      <div class="text-center" style="font-size: 28px; font-weight: 600">
        계정 활성화 필요
      </div>
      <v-spacer></v-spacer>
      <div class="d-flex flex-column align-center justify-center">
        <div style="width: 400px" class="mb-12">
          계정이 비활성화 되어있습니다. <br>
          계정 활성화 메일에서 확인 링크를 클릭하세요.
        </div>
        <div class="d-flex align-center justify-center">
          <v-btn @click="reSendAccountActivateEmail()" color="#2F54EB" dark depressed class="mb-2">
            계정 활성화 메일 재발송
          </v-btn>
        </div>
      </div>
      <v-spacer></v-spacer>
    </v-card>
  </v-dialog>

  <!-- 마이페이지 dialog -->
  <v-dialog v-model="mypageDialog" max-width="500px" :retain-focus="false">
    <v-card v-if="mypageDialog" data-testid="mypage-dialog" style="height: 90vh; max-height: 713px; border-radius: 16px; position: relative; padding: 22px 28px 18px">
      <!-- 취소 버튼 -->
      <div @click="mypageDialog = false"
        class="default-icon-btn d-flex align-center justify-center"
        style="position: absolute; top: 6px; right: 8px; width: 40px; height: 40px"
      >
        <v-icon style="font-size: 20px; color: #8A8DA8">
          mdi-close
        </v-icon>
      </div>
      <!-- title -->
      <div style="font-size: 18px; font-weight: 600; line-height: 24px; color: #0D0E17; margin-bottom: 16px">
        마이페이지
      </div>
      <!-- tabs (내 프로필, 세부 설정, 구독 및 결제) -->
      <div class="d-flex align-center justify-start" style="width: fit-content; height: 36px; background-color: #F8F9FB; border-radius: 8px; padding: 0px 2px; gap: 4px; margin-bottom: 14px">
        <!-- 내 프로필 -->
        <div @click="clickedBtnGroupIdx_mypageDialog = 0"
          class="d-flex align-center justify-center"
          :class="clickedBtnGroupIdx_mypageDialog === 0 ? '' : 'default-group-btn'"
          style="height: 32px; border-radius: 8px; padding: 0px 12px; cursor: pointer"
          :style="clickedBtnGroupIdx_mypageDialog === 0 ? {border: '1px solid #E8EAF2', backgroundColor: '#FFFFFF'} : {border: '1px solid transparent', backgroundColor: 'transparent'}"
        >
          <div style="font-size: 14px; line-height: 18px" :style="clickedBtnGroupIdx_mypageDialog === 0 ? {fontWeight: 600, color: '#0D0E17'} : {fontWeight: 500, color: '#414458'}">
            내 프로필
          </div>
        </div>
        <!-- 세부 설정 -->
        <div @click="clickedBtnGroupIdx_mypageDialog = 1"
          data-testid="mypage-detail-tab-btn"
          class="d-flex align-center justify-center"
          :class="clickedBtnGroupIdx_mypageDialog === 1 ? '' : 'default-group-btn'"
          style="height: 32px; border-radius: 8px; padding: 0px 12px; cursor: pointer"
          :style="clickedBtnGroupIdx_mypageDialog === 1 ? {border: '1px solid #E8EAF2', backgroundColor: '#FFFFFF'} : {border: '1px solid transparent', backgroundColor: 'transparent'}"
        >
          <div style="font-size: 14px; line-height: 18px" :style="clickedBtnGroupIdx_mypageDialog === 1 ? {fontWeight: 600, color: '#0D0E17'} : {fontWeight: 500, color: '#414458'}">
            세부 설정
          </div>
        </div>
        <!-- 구독 및 결제 -->
        <div @click="clickedBtnGroupIdx_mypageDialog = 2"
          class="d-flex align-center justify-center"
          :class="clickedBtnGroupIdx_mypageDialog === 2 ? '' : 'default-group-btn'"
          style="height: 32px; border-radius: 8px; padding: 0px 12px; cursor: pointer"
          :style="clickedBtnGroupIdx_mypageDialog === 2 ? {border: '1px solid #E8EAF2', backgroundColor: '#FFFFFF'} : {border: '1px solid transparent', backgroundColor: 'transparent'}"
        >
          <div style="font-size: 14px; line-height: 18px" :style="clickedBtnGroupIdx_mypageDialog === 2 ? {fontWeight: 600, color: '#0D0E17'} : {fontWeight: 500, color: '#414458'}">
            구독 및 결제
          </div>
        </div>
      </div>
      <!-- 내 프로필 -->
      <div v-if="clickedBtnGroupIdx_mypageDialog === 0" style="height: calc(100% - 90px)">
        <!-- 내용 영역 (스크롤) -->
        <div style="height: calc(100% - 28px - 40px); overflow: hidden auto; padding: 8px 4px; margin-bottom: 28px">
          <!-- picture -->
          <v-avatar :color="$store.state.user_info.personal_color ? `#${$store.state.user_info.personal_color}` : '#2F54EB'" size="60" style="margin-bottom: 16px">
            <img v-if="$store.state.user_info.picture && $store.state.user_info.picture.length > 0" :src="$store.state.user_info.picture" referrerpolicy="no-referrer">
            <div v-else-if="$store.state.user_info.email" style="font-size: 18px; font-weight: 400; line-height: 20px; color: #FFFFFF">
              {{ $store.state.user_info.email[0] }}
            </div>
          </v-avatar>
          <!-- 이름 -->
          <div style="margin-bottom: 16px">
            <!-- title -->
            <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #8A8DA8; margin-bottom: 4px">
              이름
            </div>
            <!-- 이름 입력창 및 저장하기 버튼 -->
            <div class="d-flex align-center justify-space-between">
              <!-- 이름 입력창 -->
              <input v-model="userInfo_name" data-testid="mypage-name-input" type="text"
                @click="clickModifyUserName()" @keyup.enter="modifyUserInfo('name')" @keyup.esc="closeModifyUserName()"
                @focus="isFocusModifyingUserName = true" @blur="isFocusModifyingUserName = false"
                class="focus-box-shadow-and-border-color-687EFF input-area"
                style="width: 180px; height: 32px; background-color: #ffffff; border-radius: 8px; border: 1px solid #E8EAF2; padding: 0px 12px; font-size: 14px; font-weight: 400; line-height: 18px; color: #414458"
              >
              <!-- <v-text-field v-model="userInfo_name" data-testid="mypage-name-input"
                @click="clickModifyUserName()" @keyup.enter="modifyUserInfo('name')" @keyup.esc="closeModifyUserName()"
                @focus="isFocusModifyingUserName = true" @blur="isFocusModifyingUserName = false"
                :disabled="isWritingWithdrawalCheckText"
                height="32px" background-color="#FFFFFF" color="#414458" outlined dense hide-details
                class="default-input-2" style="max-width: 180px; border-radius: 8px; font-size: 14px"
              ></v-text-field> -->
              <!-- 저장하기 버튼 -->
              <div v-if="$store.state.user_info.name !== userInfo_name || isFocusModifyingUserName" @click="modifyUserInfo('name')"
                data-testid="mypage-name-save-btn"
                class="default-white-btn d-flex align-center"
                style="height: 32px; padding: 0px 12px"
              >
                <span style="font-size: 14px; line-height: 18px">
                  저장하기
                </span>
              </div>
            </div>
          </div>
          <!-- 이메일 및 로그인 방식 -->
          <div style="margin-bottom: 16px">
            <!-- title -->
            <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #8A8DA8; margin-bottom: 4px">
              이메일
            </div>
            <!-- 이메일 및 로그인 방식 -->
            <div class="d-flex align-center" style="gap: 8px">
              <!-- 이메일 -->
              <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
                {{ $store.state.user_info.email }}
              </div>
              <!-- 로그인 방식 -->
              <div v-if="$store.state.user_info.user_type === 'google'" class="d-flex align-center justify-center" style="height: 20px; border-radius: 4px; background-color: #F0F2FF; padding: 0px 6px">
                <div style="font-size: 12px; font-weight: 500; line-height: 16px; color: #687EFF">
                  구글로그인
                </div>
              </div>
            </div>
          </div>
          <!-- divider -->
          <div style="height: 1px; width: 100%; background-color: #E8EAF2; margin-bottom: 16px"></div>
          <!-- 팀 -->
          <div style="margin-bottom: 16px">
            <!-- title -->
            <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #8A8DA8; margin-bottom: 4px">
              팀
            </div>
            <!-- 팀 -->
            <div class="d-flex align-center" style="gap: 2px">
              <!-- root -->
              <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
                {{ $store.state.user_info.organization_root_name }}
              </div>
              <!-- arrow -->
              <v-icon v-if="$store.state.user_info.organization_root !== $store.state.user_info.organization_sub" style="font-size: 18px; color: #8A8DA8">
                mdi-chevron-right
              </v-icon>
              <!-- sub -->
              <div v-if="$store.state.user_info.organization_root !== $store.state.user_info.organization_sub" style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
                {{ $store.state.user_info.organization_sub_name }}
              </div>
            </div>
          </div>
          <!-- 팀 권한 -->
          <div style="margin-bottom: 16px">
            <!-- title -->
            <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #8A8DA8; margin-bottom: 4px">
              팀 권한
            </div>
            <!-- 팀 권한 -->
            <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
              {{ $store.state.user_info.organization_permission | organizationPermissionFilter }}
            </div>
          </div>
          <!-- 플랜 -->
          <div style="margin-bottom: 16px">
            <!-- title -->
            <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #8A8DA8; margin-bottom: 4px">
              플랜
            </div>
            <!-- 플랜 -->
            <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
              {{ $store.state.user_info.plan === 'enterprise' ? '엔터프라이즈' : $store.state.user_info.plan === 'trial' ? '무료체험' : '-' }}
            </div>
          </div>
          <!-- 플랜 시작일 -->
          <div style="margin-bottom: 16px">
            <!-- title -->
            <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #8A8DA8; margin-bottom: 4px">
              플랜 시작일
            </div>
            <!-- 플랜 시작일 -->
            <div v-if="$store.state.user_info.paid_start_date" style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
              {{ $store.state.user_info.paid_start_date | dateFormatFilter }}
            </div>
            <div v-else style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
              -
            </div>
          </div>
          <!-- 기한 만료일 -->
          <div style="margin-bottom: 0px">
            <!-- title -->
            <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #8A8DA8; margin-bottom: 4px">
              기한 만료일
            </div>
            <!-- 기한 만료일 -->
            <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
              {{ $store.state.user_info.paid_expire_date | dateFormatFilter }}
            </div>
          </div>
        </div>
        <!-- 로그아웃 버튼 -->
        <div @click="clickLogoutBtn()"
          class="default-white-btn d-flex align-center justify-center"
          style="width: 100%; height: 40px"
        >
          <span style="font-size: 14px; line-height: 18px">
            로그아웃
          </span>
        </div>
        <!-- 회원탈퇴 버튼 -->
        <!-- <div class="d-flex align-end justify-center" style="width: 100%">
          <div @click="askWithdrawal()"
            style="font-size: 13px; font-weight: 400; line-height: 18px; color: #ABAEC4; cursor: pointer; margin-top: 10px"
          >
            회원탈퇴
          </div>
        </div> -->
      </div>
      <!-- 세부 설정 -->
      <div v-if="clickedBtnGroupIdx_mypageDialog === 1" style="height: calc(100% - 90px)">
        <div class="d-flex flex-column" style="height: 100%">
          <!-- 내용 영역 -->
          <div style="height: calc(100% - 40px); padding: 8px 4px">
            <!-- 언어 -->
            <div class="d-flex align-center justify-space-between" style="margin-bottom: 16px">
              <!-- title, text -->
              <div>
                <!-- title -->
                <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458; margin-bottom: 4px">
                  언어
                </div>
                <!-- text -->
                <div style="font-size: 13px; font-weight: 400; line-height: 16px; color: #8A8DA8">
                  리컬럼에서 사용할 언어를 설정할 수 있습니다.
                </div>
              </div>
              <!-- 언어 dropdown -->
              <div style="width: 98px; height: 32px">
                <v-menu offset-y bottom>
                  <!-- 선택값 -->
                  <template v-slot:activator="{ on, value }">
                    <div v-on="on" style="width: 100%; height: 100%; position: relative; cursor: pointer">
                      <!-- 선택값 및 아이콘 -->
                      <div class="d-flex align-center justify-space-between"
                        style="width: 100%; height: 100%; overflow: auto hidden; padding: 0px 8px 0px 12px; border-radius: 8px; border: 1px solid #E8EAF2; cursor: pointer"
                      >
                        <!-- 선택값 -->
                        <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458; width: 100%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                          {{ languageList.filter(v => v.value === userInfo_language)[0].text }}
                        </div>
                        <!-- 아이콘 -->
                        <v-icon :class="value ? 'up' : 'down'" style="font-size: 20px; color: #414458">
                          mdi-chevron-down
                        </v-icon>
                      </div>
                    </div>
                  </template>
                  <!-- 선택 목록 -->
                  <v-card style="width: 100%; overflow: hidden auto">
                    <div v-for="item in languageList" :key="item.value" @click="userInfo_language = item.value">
                      <div class="d-flex align-center justify-start" style="min-height: 40px; padding: 0px 16px; cursor: pointer"
                        :style="item.value === userInfo_language ? {backgroundColor: '#F0F2FF'} : {}"
                      >
                        <!-- text -->
                        <div class="list-item-text"
                          style="font-size: 14px; line-height: 18px; font-weight: 500; color: #414458"
                          :style="item.value === userInfo_language ? {color: '#687EFF', fontWeight: 600} : {}"
                        >
                          {{ item.text }}
                        </div>
                      </div>
                    </div>
                  </v-card>
                </v-menu>
              </div>
            </div>
            <!-- divider -->
            <div style="height: 1px; width: 100%; background-color: #E8EAF2; margin-bottom: 16px"></div>
            <!-- 마케팅 정보 수신 동의 -->
            <div class="d-flex align-center justify-space-between" style="margin-bottom: 16px">
              <!-- title, text -->
              <div>
                <!-- title -->
                <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458; margin-bottom: 4px">
                  마케팅 정보 수신 동의
                </div>
                <!-- text -->
                <div style="font-size: 13px; font-weight: 400; line-height: 16px; color: #8A8DA8">
                  리컬럼의 주요 업데이트 소식이 있을 때 이메일을 받습니다.
                </div>
              </div>
              <!-- 마케팅 정보 수신 동의 toggle -->
              <toggle-button data-testid="mypage-marketing-toggle"
                v-model="userInfo_marketingAllowed" @change="changeMarketingAllowedToggle(userInfo_marketingAllowed)"
                :color="{checked: '#687EFF', unchecked: '#E8EAF2'}"
                :width="40" :height="20"
              />
            </div>
          </div>
          <v-spacer></v-spacer>
          <!-- 저장하기 버튼 -->
          <div @click="modifyUserInfo()"
            data-testid="mypage-detail-save-btn"
            class="default-theme-btn d-flex align-center justify-center"
            style="width: 100%; height: 40px"
            :style="
              (
                $store.state.user_info.language !== userInfo_language || 
                $store.state.user_info.marketing_allowed !== userInfo_marketingAllowed
              ) ? {} : 
              {pointerEvents: 'none', backgroundColor: '#D8DDFF !important'}
            "
          >
            <div style="font-size: 14px; line-height: 18px">
              저장하기
            </div>
          </div>
        </div>
      </div>
      <!-- 구독 및 결제 -->
      <div v-if="clickedBtnGroupIdx_mypageDialog === 2" class="d-flex flex-column" style="height: calc(100% - 90px)">
        <!-- 상단 내용 (플랜, 플랜 시작일, 기한 만료일) -->
        <div style="padding: 8px 4px; margin-bottom: 16px">
          <!-- 플랜 -->
          <div style="margin-bottom: 16px">
            <!-- title -->
            <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #8A8DA8; margin-bottom: 4px">
              플랜
            </div>
            <!-- 플랜 -->
            <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
              {{ $store.state.user_info.plan === 'enterprise' ? '엔터프라이즈' : $store.state.user_info.plan === 'trial' ? '무료체험' : '-' }}
            </div>
          </div>
          <!-- 플랜 시작일 -->
          <div style="margin-bottom: 16px">
            <!-- title -->
            <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #8A8DA8; margin-bottom: 4px">
              플랜 시작일
            </div>
            <!-- 플랜 시작일 -->
            <div v-if="$store.state.user_info.paid_start_date" style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
              {{ $store.state.user_info.paid_start_date | dateFormatFilter }}
            </div>
            <div v-else style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
              -
            </div>
          </div>
          <!-- 기한 만료일 -->
          <div style="margin-bottom: 16px">
            <!-- title -->
            <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #8A8DA8; margin-bottom: 4px">
              기한 만료일
            </div>
            <!-- 기한 만료일 -->
            <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
              {{ $store.state.user_info.paid_expire_date | dateFormatFilter }}
            </div>
          </div>
          <!-- divider -->
          <div style="height: 1px; width: 100%; background-color: #E8EAF2"></div>
        </div>
        <!-- 하단 내용 (내용 영역 (청구 비용) / 결제하기 버튼) -->
        <div style="flex: 1">
          <!-- 내용 영역 (청구 비용) / 결제하기 버튼 -->
          <div v-if="$store.state.user_info.license_manager.id === $store.state.user_info.pk" class="d-flex flex-column" style="height: 100%">
            <!-- 내용 영역 (청구 비용) -->
            <div style="height: calc(100% - 40px); padding: 0px 4px 8px">
              <!-- 청구 비용 -->
              <div style="margin-bottom: 16px">
                <!-- title -->
                <div style="font-size: 13px; font-weight: 500; line-height: 16px; color: #8A8DA8; margin-bottom: 4px">
                  청구 비용
                </div>
                <!-- 청구 비용 -->
                <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
                  {{ $store.state.user_info.license_cost ? $store.state.user_info.license_cost : '-' }}원
                </div>
              </div>
            </div>
            <v-spacer></v-spacer>
            <!-- 결제하기 버튼 -->
            <div
              class="default-theme-btn d-flex align-center justify-center"
              style="width: 100%; height: 40px"
              :style="true ? {} : {pointerEvents: 'none', backgroundColor: '#D8DDFF !important'}"
            >
              <div style="font-size: 14px; line-height: 18px">
                결제하기
              </div>
            </div>
          </div>
          <!-- 결제 권한 x -->
          <div v-else class="d-flex align-center justify-center" style="height: 100%">
            <div style="font-size: 14px; font-weight: 500; line-height: 16px; color: #ABAEC4">
              나에게 결제 권한이 없습니다.
            </div>
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>

  <!-- 내용 복사 시 표시 snackbar -->
  <v-snackbar v-model="showCopyCompleteSnackbar" color="success" style="height: 90vh; top: 0">
    <div class="d-flex align-center">
      <v-icon>mdi-checkbox-marked-circle</v-icon>
      <div style="font-size: 16px" class="ml-2">
        내용 복사가 완료되었습니다.
      </div>
    </div>
  </v-snackbar>

  <!-- overlay(default) -->
  <v-overlay :value="$store.state.overlay" style="z-index: 9999">
    <div class="d-flex flex-column align-center" style="backdrop-filter: blur(2px)">
      <div class="mb-2 mx-12" style="font-size: 24px; font-weight: 500; color: #0D0E17">
        {{ $store.state.overlayText }}
      </div>
      <v-progress-linear
        color="#0066FF"
        indeterminate
        rounded
        height="6"
      ></v-progress-linear>
    </div>
  </v-overlay>

  <!-- overlay(데이터 업로드) -->
  <v-overlay :value="$store.state.dataUploadOverlay" style="z-index: 9999">
    <div class="d-flex flex-column align-center" style="backdrop-filter: blur(2px)">
      <div class="mb-2 mx-12" style="font-size: 24px; font-weight: 500; color: #0D0E17">
        데이터 업로드 중...
      </div>
      <div class="mb-2 mx-12" style="font-size: 24px; font-weight: 500; color: #0D0E17">
        {{ `${$store.state.currentUploadDataCnt} / ${$store.state.totalUploadDataCnt}` }}
      </div>
      <v-progress-linear
        color="#0066FF"
        indeterminate
        rounded
        height="6"
      ></v-progress-linear>
    </div>
  </v-overlay>

  <!-- dark-overlay(프로세스 아이템 변경) -->
  <div v-if="$store.state.darkOverlay" class="dark-overlay"></div>

  <!-- dark-overlay(기본 튜토리얼) -->
  <div v-if="$store.state.user_info.plan === 'trial' && $store.state.tutorialStep > 0 && $store.state.tutorialStep !== 4 && $store.state.tutorialStep !== 5 && $store.state.tutorialStep !== 6" class="tutorial-dark-overlay"></div>
  
  <!-- dark-overlay(rpa 튜토리얼) -->
  <div v-if="$store.state.user_info.plan === 'trial' && $store.state.rpaTutorialStep > 0" class="rpa-tutorial-dark-overlay"
    :style="
      $store.state.rpaTutorialStep === 3 && $store.state.rpaTutorialHighlightRect.x && $store.state.rpaTutorialHighlightRect.y && $store.state.rpaTutorialHighlightRect.w && $store.state.rpaTutorialHighlightRect.h ? 
      {
        clipPath: // 한붓그리기 형식 - 바깥 사각형 좌표 4개, 내부 사각형으로 들어가기 위한 좌표 1개, 내부 사각형 좌표 4개, 내부 사각형으로 들어가기 위한 좌표 1개
        `polygon(
          0% 0%, 100% 0%, 100% 100%, 0% 100%,
          0% ${$store.state.rpaTutorialHighlightRect.y}px, 
          ${$store.state.rpaTutorialHighlightRect.x}px ${$store.state.rpaTutorialHighlightRect.y}px, ${$store.state.rpaTutorialHighlightRect.x}px calc(${$store.state.rpaTutorialHighlightRect.y}px + ${$store.state.rpaTutorialHighlightRect.h}px), calc(${$store.state.rpaTutorialHighlightRect.x}px + ${$store.state.rpaTutorialHighlightRect.w}px) calc(${$store.state.rpaTutorialHighlightRect.y}px + ${$store.state.rpaTutorialHighlightRect.h}px), calc(${$store.state.rpaTutorialHighlightRect.x}px + ${$store.state.rpaTutorialHighlightRect.w}px) ${$store.state.rpaTutorialHighlightRect.y}px,
          0% ${$store.state.rpaTutorialHighlightRect.y}px
        )`
      } : {}
    "
  ></div>
  <!-- clipPath: `polygon(
    0% 0%, 100% 0%, 100% 100%, 0% 100%,
    0% 36px, 
    326px 36px, 326px calc(36px + 250px), calc(326px + 480px) calc(36px + 250px), calc(326px + 480px) 36px,
    0% 36px
  )` -->

  <!-- dark-overlay(데이터 모드 튜토리얼) -->
  <div v-if="$store.state.user_info.plan === 'trial' && $store.state.dataModeTutorialStep > 0" class="tutorial-dark-overlay"></div>

  <!-- 채널톡 관련 -->
  <div class="channel-talk-btn-3" style="display: hidden"></div>

  <!-- 우측 상단 비동기 작업 목록 패널 -->
  <div v-if="showAsyncTaskStatusListPanel"
    style="position: fixed; top: 8px; right: 16px; z-index: 999; width: 300px; padding: 0px 6px; border-radius: 10px; background-color: #ffffff; box-shadow: 4px 4px 8px 0px #0D0E1729"
  >
    <!-- header (expand btn / close btn) -->
    <div class="d-flex align-center justify-space-between" style="height: 44px; padding: 0px 2px 0px 10px; margin-bottom: 1px">
      <!-- title -->
      <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
        {{
          asyncTaskStatusList_filtered?.filter(v => v.status === 'Running')?.length ? 
          `${asyncTaskStatusList_filtered?.filter(v => v.status === 'Running')?.length}개 항목 진행 중` : 
          '진행 중인 항목 없음'
        }}
      </div>
      <!-- expand btn -->
      <div v-if="asyncTaskStatusList_filtered?.filter(v => v.status === 'Running')?.length" @click="expandAsyncTaskStatusListPanel = !expandAsyncTaskStatusListPanel" 
        class="default-icon-btn d-flex align-center justify-center"
        style="width: 32px; height: 32px"
      >
        <v-icon :class="expandAsyncTaskStatusListPanel ? 'down' : 'up'" style="font-size: 18px; color: #8A8DA8 !important">
          mdi-chevron-up
        </v-icon>
      </div>
      <!-- close btn -->
      <div v-else @click="clickCloseBtn_asyncTaskStatusListPanel()" 
        class="default-icon-btn d-flex align-center justify-center"
        style="width: 32px; height: 32px"
      >
        <v-icon style="font-size: 18px; color: #8A8DA8 !important">
          mdi-close
        </v-icon>
      </div>
    </div>
    <!-- list -->
    <v-expand-transition>
      <div v-show="expandAsyncTaskStatusListPanel">
        <!-- list wrapper -->
        <div class="d-flex flex-column" style="max-height: 200px; overflow: hidden auto; gap: 1px; margin-bottom: 4px">
          <div v-for="async_item in asyncTaskStatusList_filtered" :key="async_item.pk">
            <!-- list item -->
            <v-hover v-slot="{ hover }">
              <div @click="clickAsyncItem(async_item)"
                class="hover-bg-color d-flex align-center" style="--hover-bg-color: #F8F9FB; height: 56px; padding: 0px 8px; border-radius: 8px; gap: 10px; cursor: pointer"
              >
                <!-- icon box -->
                <div class="d-flex align-center justify-center" style="min-width: 38px; height: 38px; border-radius: 8px; border: 1px solid #E8EAF2; background-color: #F8F9FB">
                  <v-icon style="font-size: 20px; color: #414458">
                    {{ async_item.task_type | asyncTaskTypeIconFilter }}
                  </v-icon>
                </div>
                <!-- name / status -->
                <div>
                  <!-- name -->
                  <div style="font-weight: 500; font-size: 14px; line-height: 18px; color: #414458" v-line-clamp="1">
                    {{ async_item.name }}
                  </div>
                  <!-- status -->
                  <div style="font-weight: 400; font-size: 13px; line-height: 16px; color: #8A8DA8; margin-top: 2px">
                    {{ async_item | asyncTaskStatusListPanelStatusFilter }}
                  </div>
                </div>
                <v-spacer></v-spacer>
                <!-- status icon (hover btn) -->
                <div>
                  <div v-if="!hover || async_item.status === 'Running'">
                    <v-progress-circular v-if="async_item.status === 'Running'"
                      :size="20" :width="2" color="#D8DAE9" indeterminate
                    ></v-progress-circular>
                    <v-icon v-else-if="async_item.status === 'Finished'" style="font-size: 20px; color: #0FC314">
                      mdi-check-circle
                    </v-icon>
                    <v-icon v-else-if="async_item.status?.includes('Error') || async_item.status?.includes('Fail')" style="font-size: 20px; color: #FF0000">
                      mdi-alert-circle
                    </v-icon>
                  </div>
                  <div v-else style="min-width: 50px">
                    <div style="font-size: 13px; font-weight: 400; line-height: 16px; color: #414458">
                      {{
                        async_item.status === 'Running' ? '취소하기' : 
                        async_item.status === 'Finished' ? '결과 보기' : 
                        async_item.status?.includes('Error') || async_item.status?.includes('Fail') ? '확인하기' : 
                        ''
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </v-hover>
          </div>
        </div>
      </div>
    </v-expand-transition>
  </div>
</v-app>
